import Url from 'url-parse';
import Cookies from 'js-cookie';
import ajaxHook from 'ajax-hook';
import EventEmitter from 'events';
import UAParser from 'ua-parser-js';
import { getUserDeviceId, getTimestamp } from '@gaoding/user-device-id/es/index';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

// import Cookies from 'js-cookie';
// let domain = '';

/**
 * 获取当前顶级域名。
 * @return {string}
 */
function getDomain() {
  if (/^(.+\.)*gaoding.com/i.test(window.location.hostname)) {
    var domain = '.gaoding.com';
    return domain;
  }

  return '.' + window.location.hostname; // let names = window.location.hostname.split('.');
  // const hostnames = names.slice(-1);
  // names = names.slice(0, -1);
  // domain = window.location.hostname;
  // while(names.length) {
  //     hostnames.unshift(names.pop());
  //     const d = (names.length ? '.' : '') + hostnames.join('.');
  //     Cookies.set('gd_tracker_domain', '1', {
  //         domain: d
  //     });
  //     if(Cookies.get('gd_tracker_domain')) {
  //         domain = hostnames.join('.');
  //         break;
  //     }
  // }
  // Cookies.remove('gd_tracker_domain', {
  //     domain,
  // });
  // return domain;
}

var RouterChangeTracker =
/*#__PURE__*/
function () {
  /**
   * 是否为第一次触发路由。
   * @type {boolean}
   * @private
   */

  /**
   * 当前路由的 page，作为跳出页面的 source_page。
   * @type {Object}
   * @private
   */

  /**
   * @param {module:tracker/wind/tracker~WindTracker} tracker WindTracker 实例
   * @param {Object} options 插件选项
   * @param {Object} options.app vue 实例
   * @param {Object} options.router vue-router 实例
   * @param {Object} [options.eventId] 事件 ID
   * @param {('beforeEach'|'afterEach')} options.routerGuardName vue 上报 PV 的路由守卫方法名字
   */
  function RouterChangeTracker(tracker, options) {
    var _this$options$app, _this$options$app$con, _this$options$app$con2;

    _classCallCheck(this, RouterChangeTracker);

    _defineProperty(this, "firstRouteTriggered", false);

    _defineProperty(this, "page", null);

    var defaultOptions = {
      app: null,
      routerGuardName: 'afterEach' // 触发上报 PV 的路由守卫名字，支持 beforeEach 以及 afterEach。

    };
    this.options = Object.assign(defaultOptions, options);
    if (!this.options.app) return;

    if (this.options.app.$router) {
      this.initVue2Router(tracker, this.options.app.$router);
    } else if (typeof this.options.app.router !== 'undefined') {
      // 适配 nuxt
      this.initVue2Router(tracker, this.options.app.router);
    }

    if ((_this$options$app = this.options.app) !== null && _this$options$app !== void 0 && (_this$options$app$con = _this$options$app.config) !== null && _this$options$app$con !== void 0 && (_this$options$app$con2 = _this$options$app$con.globalProperties) !== null && _this$options$app$con2 !== void 0 && _this$options$app$con2.$router) {
      this.initVue3Router(tracker);
    }
  }
  /**
   * 初始化 vue router
   *
   * @param {*} tracker
   * @memberof RouterChangeTracker
   */


  _createClass(RouterChangeTracker, [{
    key: "initVue2Router",
    value: function initVue2Router(tracker, router) {
      var _this = this;

      // 完成初始导航时上报 PV 事件。
      router.onReady(function () {
        _this.routerOnReady(tracker, router);
      }); // 路由变化时上报 PV 事件。

      router[this.options.routerGuardName](function (to, from, next) {
        _this.routerGuard(tracker, to, from);

        if (_this.options.routerGuardName === 'beforeEach') next();
      });
    }
    /**
     * 初始化 vue3 router
     * @param {*} tracker
     * @memberof RouterChangeTracker
     */

  }, {
    key: "initVue3Router",
    value: function initVue3Router(tracker) {
      var _this2 = this;

      var router = this.options.app.config.globalProperties.$router;
      router.isReady().then(function () {
        _this2.routerOnReady(tracker, router);
      });
      router[this.options.routerGuardName](function (to, from) {
        _this2.routerGuard(tracker, to, from);
      });
    }
    /**
     * 路由初始化完成
     * @param {*} tracker
     * @param {*} router
     * @memberof RouterChangeTracker
     */

  }, {
    key: "routerOnReady",
    value: function routerOnReady(tracker, router) {
      if (!this.firstRouteTriggered) {
        var currentRoute = router.currentRoute;
        var page = this.getPage(currentRoute);
        var sourcePage = this.getSourcePage();
        var details = {};

        if (typeof this.options.change === 'function') {
          var otherDetails = this.options.change(router.history && router.history.current);
          Object.assign(details, otherDetails);
        }

        if (this.options.eventId) details.event_id = this.options.eventId;
        tracker.set('event', {
          page: page.path,
          page_params: page.params,
          source_page: sourcePage,
          page_time: Date.now()
        });
        tracker.emit('router.ready');
        tracker.trackPageView(details);
        this.firstRouteTriggered = true;
      }
    }
    /**
     * 无垠埋点 page 参数生成方式。
     * 若 route.meta.alias 存在，则 page = hostname + alias;
     * 否则默认为 page = hostname + 当前匹配的路由路径。
     * @param {Object} route vue 路由
     * @return {string}
     */

  }, {
    key: "routerGuard",
    value: function routerGuard(tracker, to, from) {
      var page = this.getPage(to);
      var details = {};
      var fields = {
        page: page.path,
        page_params: page.params,
        page_time: Date.now()
      }; // 第一次路由跳转不需要添加 source_page 参数

      if (!this.firstRouteTriggered) {
        var sourcePage = this.getSourcePage();
        fields.source_page = sourcePage; // 需要 page 相关参数的事件可以监听 router.ready 事件

        tracker.set('event', fields);
        tracker.emit('router.ready');
        this.firstRouteTriggered = true;
      } else {
        var _sourcePage = this.getSourcePage(from);

        fields.source_page = _sourcePage;
        tracker.set('event', fields);
      }

      if (typeof this.options.change === 'function') {
        var otherDetails = this.options.change(from, to);
        Object.assign(details, otherDetails);
      }

      if (this.options.eventId) details.event_id = this.options.eventId;
      tracker.trackPageView(details);
    }
    /**
     * 无垠埋点 page 参数生成方式。
     * 若 route.meta.alias 存在，则 page = hostname + alias;
     * 否则默认为 page = hostname + 当前匹配的路由路径。
     * @param {Object} route vue 路由
     * @return {string}
     */

  }, {
    key: "getPath",
    value: function getPath(route) {
      var path = '';
      var alias = route.meta && route.meta.alias;

      if (alias) {
        path = alias;
      } else {
        var matched = route.matched;
        path = matched && matched.length && matched[matched.length - 1] && (matched[matched.length - 1].path || '/');
      }

      var fullPath = location.host + path;
      /**
       * Remove Custom Matching Parameters
       * @see {@link https://github.com/pillarjs/path-to-regexp#custom-matching-parameters}
       */

      var resolvedPath = fullPath.replace(/\(.*?\)/g, '');
      return resolvedPath;
    }
    /**
     * 解析 vue 路由。
     * @param {string} route vue 路由
     * @return {Object}
     */

  }, {
    key: "getPage",
    value: function getPage(route) {
      var page = {};
      var path = this.getPath(route);
      var params = stringifyObject(Object.assign({}, route.params, route.query));
      page.path = path;
      if (Object.keys(params).length) page.params = params;
      return page;
    }
    /**
     * 获取 当前页面的 source_page。
     * source_page 来源有 2 种：
     *   1. 第一次进入页面，判断 document.referrer 的顶级域名是否与当前页面一致，如果是则写入 source_page；
     *   2. 来自于前端路由跳转。
     * @param {Object} [route] vue 路由
     * @return {string|undefined}
     */

  }, {
    key: "getSourcePage",
    value: function getSourcePage(route) {
      if (!route) {
        var referrer = document.referrer;
        var domain = getDomain();

        if (referrer) {
          var url = new Url(referrer);

          if (url.hostname && url.hostname.includes(domain)) {
            return url.host + url.pathname;
          }
        }

        return undefined;
      }

      return location.hostname + route.fullPath;
    }
  }]);

  return RouterChangeTracker;
}();

function stringifyObject(obj) {
  return Object.keys(obj).reduce(function (result, key) {
    if (![undefined, null, NaN].includes(obj[key])) {
      result[key] = '' + obj[key];
    }

    return result;
  }, {});
}

/**
 * 事件 ID。
 * @enum {number}
 * @readonly
 */
var EVENT_ID = {
  page_visit: 39003,
  login: 39001,
  utm_click: 6,
  user_profile: 7,
  page_duration: 39022,
  regist: 39004,
  order_pay_expose: 32001,
  order_pay_action: 32002,
  material_expose: 33001,
  material_click: 33002,
  resource_loc_click: 35002,
  resource_loc_expose: 35001,
  search: 39005,
  dialog_action: 39013,
  dialog_expose: 39012
};
var INIT_EVENT_DETAILS = {
  login: {
    client_name: '',
    is_cache_login: '',
    is_verify_code_login: '',
    login_type: ''
  },
  regist: {
    regist_channel_type: '',
    // string 注册方式 主站 手机 微信 QQ
    regist_cust_id: '',
    // string 注册用户ID 上报用户注册后的用户ID
    telephone: '' // string 绑定手机号 绑定手机号码（有则上报）

  },
  order_pay_expose: {
    business_name: '',
    // string 业务线名称
    editor_type: '',
    // string 编辑器类型
    material_id: '',
    // string 模板ID
    material_ids: [],
    // array/string 素材IDs 如需要上报模板内素材ids，则上报
    order_type: '',
    // string 订单类型
    source: '',
    // string 曝光来源
    source_location: '',
    // string 曝光来源位置
    spu: '',
    // string 订单对应的spu
    type: '',
    // string 弹窗类型
    work_id: '' // string 作品ID

  },
  order_pay_action: {
    business_name: '',
    // string 业务线名称
    action_type: '',
    // string 操作类型  订单生成 订单支付
    editor_type: '',
    // string 编辑器类型
    material_id: '',
    // string 模板ID
    material_ids: [],
    // array/string 素材IDs
    order_no: '',
    // string 订单号
    order_type: '',
    // string 订单类型  会员 单购
    pay_amount: '',
    // number 支付金额
    sku: [],
    // array/string 订单对应的sku
    source: '',
    // string 操作来源
    source_location: '',
    // string 操作来源位置
    spu: '',
    // string 订单对应的spu
    status: '',
    // boolean 操作状态  0:失败  1:成功
    type: '',
    // string 页面类型
    work_id: '' // string 作品ID

  },
  material_expose: {
    dist_id: '',
    // string 分发id
    base_score: '',
    // string es基础得分
    dist_code: '',
    // string 分发标识
    expose_source: '',
    // string 曝光来源
    expose_source_editor: '',
    // string 曝光来源_编辑器
    expose_source_fun_tab: '',
    // string 编辑器功能tab
    expose_source_label: '',
    // string 模块标签
    expose_source_label_id: '',
    // string 模块标签ID
    expose_source_topic_id: '',
    // string 曝光来源_专题ID
    expose_source_topic_loc: '',
    // integer 曝光来源_专题位置
    expose_source_topic_title: '',
    // string 曝光来源_专题名称
    filter_one: [],
    // array/string 一级（用途）筛选结果
    filter_three: [],
    // array/string 筛选结果预留字段1
    filter_two: [],
    // array/string 二级（场景）筛选结果
    fliter_four: [],
    // array/string 筛选结果预留字段1
    material_id: '',
    // string 素材模板ID
    material_location: '',
    // integer 模板位置
    picture_url: '',
    // string 用户上传图片地址 图搜功能用户上传的图片地址
    project_name: '',
    // string 项目名称
    ratio_bucket: '',
    // string 比例分桶标识
    score: '',
    // string LR得分
    search_terms: '',
    // string 搜索词
    search_word_type: '',
    // string 搜索词类型
    scene: '',
    // string 场景
    filter_five: '',
    filter_four: '',
    filter_six: '',
    position: ''
  },
  material_click: {
    click_source_topic_title: '',
    // string 点击来源_专题名称
    click_type: '',
    // string 点击类型 播放 使用
    dist_code: '',
    // string分发标识
    dist_id: '',
    // string分发id
    filter_one: [],
    // array/string 一级（用途）筛选结果
    filter_three: [],
    // array/string 筛选结果预留字段1
    filter_two: [],
    // array/string 二级（场景）筛选结果
    fliter_four: [],
    // array/string 筛选结果预留字段2
    is_batch: '',
    // integer 是否开启批量 记录是否批量添加素材
    material_id: '',
    // string 素材模板ID
    material_location: '',
    // integer 模板位置
    picture_url: '',
    // string 用户上传图片地址 图搜功能用户上传的图片地址
    project_name: '',
    // string 项目名称
    ratio_bucket: '',
    // string 比例分桶
    score: '',
    // string LR得分
    search_terms: '',
    // string 搜索词
    search_word_type: '',
    // string 搜索词类型
    scene: '',
    // string 场景
    base_score: '',
    // string es得分
    canvas_number: '',
    // integer 画布张数 有批量功能的编辑器使用该字段记录批量添加素材的画布张数
    click_source: '',
    // string 点击来源
    click_source_editor: '',
    // string 点击来源_编辑器
    click_source_fun_tab: '',
    // string 编辑器功能tab
    click_source_label: '',
    // string 模块标签
    click_source_label_id: '',
    // string 模块标签ID
    click_source_topic_id: '',
    // string 点击来源_专题ID
    click_source_topic_loc: '',
    // integer 点击来源_专题位置
    filter_five: '',
    filter_four: '',
    filter_six: '',
    position: ''
  },
  resource_loc_click: {
    click_type: '',
    // string 点击类型 上报具体操作类型
    banner_id: '',
    // integer 广告位ID
    banner_location: '',
    // integer banner位置（同一资源位内） 同一资源位内部，不同banner对应的位置（可能是轮播，也可能是平铺，具体根据运营定义），从左到右，从上到下1—N
    banner_title: '',
    // string 广告位名称
    click_source: '',
    // string 入口来源 首页， 场景页， 模板中心， 场景页-模板中心
    design_category_id: '',
    // integer 设计分类ID
    design_category_title: '',
    // string 设计分类名称
    filter_id: '',
    // integer 筛选器ID
    filter_title: '',
    // string 筛选器名称
    hot_word_id: '',
    // integer 热词ID
    hot_word_title: '',
    // string 热词名称
    notice_id: '',
    // integer 公告ID
    resource_id: '',
    // integer 资源位ID
    resource_title: '',
    // string 资源位名称
    resource_type: '',
    // string 资源位类型 左侧导航栏，设计工具集，首页-广告，场景页-广告，模板中心-广告，场景页-模板中心广告，首页-热词，场景页-热词，首页-推荐场景，场景页-推荐场景筛选条件
    search_terms: '',
    // string 搜索词专题在搜索结果页的点
    topic_id: '',
    // integer 专题ID
    topic_location: '',
    // string 专题位置
    topic_title: '',
    // string 专题名称
    scene: '' // string 场景名称

  },
  resource_loc_expose: {
    filter_title: '',
    // string 筛选器名称
    hot_word_id: '',
    // integer 热词ID
    hot_word_title: '',
    // string 热词名称
    resource_id: '',
    // integer 资源位ID
    resource_title: '',
    // string 资源位名称
    resource_type: '',
    // string 资源位类型 左侧导航栏，设计工具集，首页-广告，场景页-广告，模板中心-广告，场景页-模板中心广告，首页-热词，场景页-热词，首页-推荐场景，场景页-推荐场景筛选条件
    search_terms: '',
    // string 搜索词 专题在搜索结果页的曝光
    topic_id: '',
    // integer 专题ID
    topic_location: '',
    // string 专题位置
    topic_title: '',
    // string 专题名称
    scene: '',
    // string 场景名称
    notice_id: '',
    // integer 公告ID
    banner_id: '',
    // integer 广告位ID
    banner_location: '',
    // integer banner位置（同一资源位内） 同一资源位内部，不同banner对应的位置（可能是轮播，也可能是平铺，具体根据运营定义），从左到右，从上到下1—N
    banner_title: '',
    // string 广告位名称
    click_source: '',
    // string 入口来源 首页， 场景页， 模板中心， 场景页-模板中心
    design_category_id: '',
    // integer 设计分类ID
    design_category_title: '',
    // string 设计分类名称
    filter_id: '',
    // integer 筛选器ID
    position: '',
    words_titles: ''
  },
  search: {
    channel_titles: [],
    // array/string 用途分类名称 当search_source包含“模板中心”关键字时，上报  注：当包含多个用途分类时，一起上报，如：  channel_titles="新媒体，动态海报"
    color: '',
    // string 颜色 全部，红色，绿色，......
    design_category_id: '',
    // integer 素材类型id 素材库使用
    design_category_title: '',
    // string 素材类型名称 素材库使用
    design_title: '',
    // string 设计分类名称 当search_source包含“模板中心”关键字时，上报
    filter_id: '',
    // string 筛选器ID
    filter_one: [],
    // array/string 一级（用途）筛选结果
    filter_three: [],
    // array/string 筛选预留字段1
    filter_two: [],
    // array/string 二级（场景）筛选结果
    fliter_four: [],
    // array/string 筛选预留字段2
    format: '',
    // string 版式
    industry_title: '',
    // string 行业分类名称 当search_source包含“模板中心”关键字时，上报
    industry_titles: [],
    // array/string 行业名称[数组] 替换行业名称[string]
    search_picture_type: '',
    // string 图片搜索方式
    search_result_number: '',
    // integer 搜索结果总数 报用户搜索后的结果总数，无结果则报0
    search_source: '',
    // string 搜索来源 发现页，模板中心，专题详情页，场景页，场景页-模板中心，关于我们，帮助中心，功能介绍，最新文章，其他
    search_type: '',
    // string 搜索类型 搜索栏-搜索，筛选器-点击，both
    search_word: '',
    // string 搜索词 上报具体的搜索词，如：游泳健身、活动、抖音等；
    search_word_type: '',
    // string 搜索词类型 热门搜索词，手动输入搜索词，历史搜索词，联想搜索词，运营配置，其他，默认搜索词；注：search_type=“搜索栏专用” 和 “搜索栏和筛选器” 时，上报
    sort_type: '',
    // string 排序类型 综合排序，最新上传，最多下载
    style: '',
    // string 风格 全部，文艺，奢华，......
    scene: '',
    // string 场景名称
    filter_five: '',
    filter_four: '',
    filter_six: '',
    position: ''
  },
  dialog_action: {
    store_num: '',
    // integer 店铺数量
    action_type: '',
    // string 操作类型 点击按钮名称，如关闭、查看更多、立即作图等
    dialog_content: [],
    // array/string 弹窗内容 用户标签搜集（教育培训，人事行政，餐饮美食）
    id: '',
    // integer 弹窗id
    notice_id: '',
    // integer 公告ID
    source: '',
    // string 弹窗来源 指事件发生的页面类/场景类
    source_location: '',
    // string 弹窗位置 页面的具体位置
    title: '' // string 弹窗标题

  },
  dialog_expose: {
    notice_id: '',
    // integer 公告ID
    id: '',
    // integer 弹窗id
    source: '',
    // string 弹窗来源 指事件发生的页面类/场景类
    source_location: '',
    // string 弹窗位置 页面的具体位置
    title: '' // string 弹窗名称

  }
};

/**
 * 获取 utm 相关字段。
 * @return {Object}
 */

var getUtmData = function getUtmData() {
  var utmData = null;

  try {
    var utmDataBase64 = Cookies.get('utm_data');
    var utmJSON = decodeURIComponent(escape(atob(utmDataBase64)));
    utmData = JSON.parse(utmJSON);
  } catch (e) {// ignore error
  }

  return utmData;
};

/**
 * 上报 utm_click 事件插件类。
 */

var UtmDataTracker =
/**
 * utm 数据，用于判断是否上报 utm_click 事件。
 * @type {Object}
 * @private
 */

/**
 * @param {module:trackers/wind/tracker} tracker 无垠数据跟踪器实例。
 * @param {Object} options 插件选项
 * @param {boolean} [options.inVue=true] 是否在 Vue 下使用
 */
function UtmDataTracker(tracker, options) {
  _classCallCheck(this, UtmDataTracker);

  _defineProperty(this, "utmData", null);

  var defaultOptions = {
    inVue: true
  };
  var utmData = getUtmData();
  this.options = Object.assign(defaultOptions, options);

  function trackUtmClick() {
    tracker.trackEvent('utm_click', {
      event_id: EVENT_ID.utm_click
    });
    Cookies.remove('utm_switch', {
      domain: getDomain()
    });
  }

  if (utmData) {
    var fieldsObject = {
      utm: {
        type: utmData.type,
        from: utmData.from,
        enter: utmData.enter,
        target_page: utmData.target_page,
        medium: utmData.medium,
        plan: utmData.plan,
        element: utmData.element,
        keyword: utmData.keyword
      }
    };
    tracker.set('basic', fieldsObject);
    var utmSwitched = Cookies.get('utm_switch') === '1';

    if (utmSwitched) {
      if (this.options.inVue) {
        tracker.on('router.ready', trackUtmClick);
      } else {
        setTimeout(trackUtmClick, 0);
      }
    }
  }
};

/**
 * 重写对象的方法。
 * @param {Object} context 上下文。
 * @param {string} methodName 待重写的上下文方法。
 * @param {Function} method 重写的方法。
 */
function overrideMethod(context, methodName, method) {
  var originalMethod = context[methodName];
  context[methodName] = method(originalMethod);
}

var hookAjax = ajaxHook.hookAjax;
var requestId = 0;
var inited = false;
var state = {};
var store = {
  /**
   * 获取对应请求 ID 的数据。
   * @param {number} requestId 请求 ID。
   * @return {Object|undefined}
   */
  get: function get(requestId) {
    return state[requestId];
  },

  /**
   * 保存对应请求 ID 的数据。
   * @param {number} requestId 请求 ID。
   * @param {Object} data 待存储的数据。
   */
  set: function set(requestId, data) {
    state[requestId] = Object.assign({}, state[requestId], data);
  }
};
/**
 * 给请求带上请求 ID。
 * @return {Object}
 */

function createRequestId() {
  if (inited) return store;
  overrideFetch();
  overrideXMLHttpRequest();
  inited = true;
  return store;
}
/**
 * Monkey patch Response.
 */

function overrideFetch() {
  if (!Response) return;
  overrideMethod(Response.prototype, 'json', function (originalMethod) {
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return originalMethod.apply(this, args).then(function (json) {
        var rid = ++requestId;
        var url = new Url(_this.url); // 存储 requestId 对应的数据

        store.set(requestId, {
          uri_path: url.pathname,
          uri_query: url.query,
          bi_meta: _this.headers.get('bi_meta') || ''
        }); // 把 requestId 写入 json 数据中

        return addRequestId(json, rid);
      });
    };
  });
}
/**
 * Monkey patch XMLHttpRequest.
 */


function overrideXMLHttpRequest() {
  if (!XMLHttpRequest) return;
  hookAjax({
    open: function open(args) {
      var _args = _slicedToArray(args, 2),
          method = _args[0],
          rawUrl = _args[1];

      if (method && method.toUpperCase() === 'GET') {
        // 给当前 XMLHttpRequest 实例添加 _rid 属性
        var rid = this._rid = ++requestId;
        var url = new Url(rawUrl);
        store.set(rid, {
          uri_path: url.pathname,
          uri_query: url.query
        });
      }
    },
    onreadystatechange: handleResponse,
    onload: handleResponse,
    responseText: {
      getter: function getter(v, xhr) {
        return xhr._response;
      }
    },
    response: {
      getter: function getter(v, xhr) {
        return xhr._response;
      }
    }
  });
}
/**
 * 处理请求响应。
 * @param {Object} xhr 请求代理对象。
 */


function handleResponse(xhr) {
  if (!xhr._resolved && xhr.readyState === 4 && xhr._rid) {
    var biMeta = xhr.getResponseHeader('bi_meta') || '';
    store.set(xhr._rid, {
      bi_meta: biMeta
    });
    xhr._resolved = true; // 把 requestId 写入 json 数据中

    var contentType = xhr.getResponseHeader('Content-Type');

    if (contentType && contentType.includes('json')) {
      var responseData = null;

      if (!xhr.responseType || xhr.responseType === 'text') {
        try {
          responseData = JSON.parse(xhr.responseText);
          xhr.responseType = 'json';
        } catch (e) {// ignore error
        }
      } else if (xhr.responseType === 'json') {
        responseData = xhr.response;
      }

      if (responseData) {
        xhr._response = addRequestId(responseData, xhr._rid);
      }
    }
  }
}
/**
 * 给 JSON 数据加上请求 ID。
 * @param {any} json JSON 数据。
 * @param {number} rid 请求 ID。
 * @return {any}
 */

function addRequestId(json, rid) {
  if (Array.isArray(json)) {
    json = json.map(function (item) {
      if (item !== null && _typeof(item) === 'object') {
        return _objectSpread({}, item, {
          request_id: rid
        });
      }

      return item;
    });
  } else if (json !== null && _typeof(json) === 'object') {
    json = _objectSpread({}, json, {
      request_id: rid
    });
  }

  return json;
}

/**
 * 用于上报接口相关数据 uri_path, uri_query, bi_meta 的插件类。
 */

var ApiResponseTracker = function ApiResponseTracker(tracker) {
  var _this = this;

  _classCallCheck(this, ApiResponseTracker);

  this.requestStore = createRequestId();
  var trackEvent = tracker.trackEvent;

  tracker.trackEvent = function (event, details, scopeObject, callback) {
    if (typeof scopeObject === 'function') {
      callback = scopeObject;
      scopeObject = undefined;
    }

    scopeObject = scopeObject || {};
    var eventFields = scopeObject.event = scopeObject.event || {};
    /* eslint-disable camelcase */

    var request_id = details.request_id,
        restDetails = _objectWithoutProperties(details, ["request_id"]); // 根据请求 ID 获取 uri_path, uri_query, bi_meta


    if (request_id) {
      Object.assign(eventFields, _this.requestStore.get(request_id));
    }

    trackEvent.call(tracker, event, restDetails, scopeObject, callback);
  };
};

/**
 * abtest 无垠数据插件。
 */
var ABTestDataTracker = function ABTestDataTracker(tracker, options) {
  var _this = this;

  _classCallCheck(this, ABTestDataTracker);

  var defaultOptions = {
    abtest: null
  };
  this.options = Object.assign(defaultOptions, options);
  if (!this.options.abtest) return;
  this.options.abtest.on('windTrack', function (res) {
    if (res && res.event) {
      var event = res.event,
          abTags = res.ab_tags,
          details = _objectWithoutProperties(res, ["event", "ab_tags"]);

      tracker.trackEvent(event, details, {
        event: {
          ab_tags: abTags
        }
      });
    }
  });
  tracker.beforeEach(function (store, next) {
    var eventId = store.get('common').event_id;
    var abtest = _this.options.abtest;

    if (abtest.getCache()) {
      var abTags = abtest.getSyncAbTags(eventId);

      if (abTags) {
        store.set('event', {
          ab_tags: abTags
        });
      }

      next(store);
      return;
    }

    abtest.getAsyncAbTags(eventId).then(function (abTags) {
      if (abTags) {
        store.set('event', {
          ab_tags: abTags
        });
      }

      next(store);
    });
  });
};

/**
 * @export
 * @param {Function} func 执行函数
 * @param {Number} delay 延迟事件
 * @param {Boolean} immediate 是否立即执行
 * @returns {Function}
 */
function debounce(func, delay, immediate) {
  var timer = null;
  return function () {
    var _this = this,
        _arguments = arguments;

    var callNow = !timer;

    if (timer) {
      clearTimeout(timer);
    }

    if (immediate) {
      // 立即实行
      timer = setTimeout(function () {
        timer = null;
      }, delay);

      if (callNow) {
        func.apply(this, arguments);
      }
    } else {
      // 非立即执行
      timer = setTimeout(function () {
        func.apply(_this, _arguments);
      }, delay);
    }
  };
}

/** @module */

/**
 * 打印错误信息到控制台。
 * @param {string} msg 错误信息。
 */
function error(msg) {
  console && console.error("[gd-tracker error]: ".concat(msg));
}
/**
 * 打印警告信息到控制台。
 * @param {string} msg 警告信息。
 */

function warn(msg) {
  console && console.warn("[gd-tracker warn]: ".concat(msg));
}
/**
 * 打印普通信息到控制台。
 * @param {string} msg 普通信息。
 */

function info(msg) {
  console && console.log("[gd-tracker info]: ".concat(msg));
}
/**
 * 打印普通信息到控制台。
 * @param {string} title 信息标题
 * @param {Array} array 列表信息。
 */

function arrayInfo(title, array) {
  console && console.log("[gd-tracker info]: ".concat(title));
  console && console.table(array);
}

/**
 *  需求链接：https://jira.huanleguang.com/browse/FRONTEND-43
 * 上报 page duration 事件插件类。
 */

var PageDurationTracker =
/*#__PURE__*/
function () {
  /**
     * 页面访问持续时长记录
     * @type {Array}
     * @private
     */
  // {start, end}

  /**
   * 页面活跃持续时长记录
   * @type {Array}
   * @private
   */
  // {start, end}
  function PageDurationTracker(tracker, options) {
    _classCallCheck(this, PageDurationTracker);

    _defineProperty(this, "visitRecord", []);

    _defineProperty(this, "activeRecord", []);

    var defaultOptions = {
      eventId: EVENT_ID.page_duration
    };
    this.options = Object.assign(defaultOptions, options);
    this.tracker = tracker;
    this.showLog = tracker.showLog;
    this.eventData = {};
    this.initHistoryEvent();
    this.addEventListener();
  }

  _createClass(PageDurationTracker, [{
    key: "initHistoryEvent",
    value: function initHistoryEvent() {
      window.history.pushState = this.wrEvent('pushState');
      window.history.replaceState = this.wrEvent('replaceState');
    }
  }, {
    key: "visitStartRecord",
    value: function visitStartRecord() {
      this.eventData = this.tracker.get('event'); // 缓存 page， source_page 等信息

      this.visitRecord.push({
        start: new Date().getTime()
      });
    }
  }, {
    key: "visitEndRecord",
    value: function visitEndRecord() {
      var lastRecord = this.visitRecord[this.visitRecord.length - 1];

      if (lastRecord) {
        lastRecord.end = new Date().getTime();
      }
    }
  }, {
    key: "activeStartRecord",
    value: function activeStartRecord() {
      this.eventData = this.tracker.get('event');
      this.activeRecord.push({
        start: new Date().getTime()
      });
    }
  }, {
    key: "activeEndRecord",
    value: function activeEndRecord() {
      var lastRecord = this.activeRecord[this.activeRecord.length - 1];

      if (lastRecord) {
        lastRecord.end = new Date().getTime();
      }
    }
  }, {
    key: "endRecord",
    value: function endRecord() {
      var _this = this;

      this.visitEndRecord();
      this.activeEndRecord();
      this.trackEvent(function () {
        _this.visitStartRecord();

        _this.activeStartRecord();
      });
    }
  }, {
    key: "addEventListener",
    value: function addEventListener() {
      var _this2 = this;

      var stateChangeEvent = debounce(function () {
        return _this2.stateChangeEvent();
      }, 500, true);
      window.addEventListener('load', function () {
        _this2.loadEvent(); // replaceState 在 load 之后注册，避免和 load 同时触发


        window.addEventListener('replaceState', stateChangeEvent);
      }); // window.addEventListener('visibilitychange', () => this.visibilitychangeEvent());  去掉中间状态 @诺一

      window.addEventListener('beforeunload', function () {
        return _this2.beforeunloadEvent();
      });
      window.addEventListener('popstate', stateChangeEvent);
      window.addEventListener('pushState', stateChangeEvent);
      window.addEventListener('focus', function () {
        return _this2.focusEvent();
      });
      window.addEventListener('blur', function () {
        return _this2.blurEvent();
      });
    }
  }, {
    key: "loadEvent",
    value: function loadEvent() {
      this.visitStartRecord();
      this.activeStartRecord();
    }
  }, {
    key: "visibilitychangeEvent",
    value: function visibilitychangeEvent() {
      if (document.hidden) {
        this.activeEndRecord();
      }

      if (!document.hidden) {
        this.activeStartRecord();
      }
    }
  }, {
    key: "beforeunloadEvent",
    value: function beforeunloadEvent() {
      this.endRecord();
    }
  }, {
    key: "stateChangeEvent",
    value: function stateChangeEvent() {
      this.endRecord();
    }
  }, {
    key: "focusEvent",
    value: function focusEvent() {
      this.visitStartRecord();
    }
  }, {
    key: "blurEvent",
    value: function blurEvent() {
      this.visitEndRecord();
    }
  }, {
    key: "wrEvent",
    value: function wrEvent(type) {
      var orig = history[type];
      return function () {
        var rv = orig.apply(this, arguments);
        var e = new Event(type);
        e.arguments = arguments;
        window.dispatchEvent(e);
        return rv;
      };
    }
  }, {
    key: "trackEvent",
    value: function trackEvent(callback) {
      var eventId = this.options.eventId;

      var getDuration = function getDuration(records) {
        var duration = 0;
        records.forEach(function (record) {
          if (record.end && record.start) {
            duration += record.end - record.start;
          }
        });
        return duration;
      };

      var visitDuration = getDuration(this.visitRecord);
      var activeDuration = getDuration(this.activeRecord);

      if (this.showLog) {
        arrayInfo("\u9875\u9762\u4F7F\u7528\u65F6\u957F active_duration : ".concat(activeDuration, " ms"), this.activeRecord);
        arrayInfo("\u9875\u9762\u5B9E\u9645\u505C\u7559\u65F6\u957F visit_duration : ".concat(visitDuration, " ms"), this.visitRecord);
      }

      this.visitRecord = [];
      this.activeRecord = [];
      this.tracker.trackEvent('page_duration', {
        event_id: eventId,
        active_duration: activeDuration,
        visit_duration: visitDuration
      }, {
        event: _objectSpread({}, this.eventData)
      });

      if (callback) {
        callback();
      }
    }
  }]);

  return PageDurationTracker;
}();

/** @component gdTracker */

/**
 * @desc 统计入口组件，根据提供的参数设置初始化统计插件
 * @prop {Boolean} [is-prod=false] - 是否是production模式，非production模式下会在console内显示神策log
 * @prop {Boolean} [debug-mode=false] - 是否是debug模式，debug模式下会使用神策debug模式的API
 * @prop {Boolean} [disabled=false] - 是否禁用tracker, 禁用时tracker不初始化,所有directive均无法使用
 *
 * @fires sensor:ready
 *
 * @example
 * // app.vue
 * <template>
 *     <gd-tracker :is-prod='isProd'
 *         :debug-mode="debugMode"
 *         :options="trackerOptions"
 *         \@ready:sensor="onSensorReady">
 *         <section id='app'>
 *             App
 *         </section>
 *     </gd-tracker>
 * </template>
 * <script>
 * export default {
 *     data() {
 *          return {
 *              debugMode: true,
 *              isProd: false,
 *              trackerOptions: {
 *                  sa: {
 *                      name: 'sa',
 *                      sdk_url: 'link_to_sensordata.min.js',
 *                      heatmap_url: 'link_to_heatmap.min.js',
 *                      server_host: 'https://sensor-data.dancf.com',
 *                      project: 'gaoding_dev',
 *                      debug: true,
 *                      heatmap: {},
 *                      show_log: true
 *                  },
 *                  _hmt: {
 *                      name: '_hmt',
 *                      projectId: 'your_baidu_app_id'
 *                  },
 *                  gio: {
 *                      name: 'gio',
 *                      projectId: 'your_gio_app_id'
 *                  }
 *              }
 *         };
 *     }
 * }
 * </script>
 */
var gdTracker = {
  name: 'gdTracker',
  render: function render() {
    if (this.$slots.default) {
      if (this.$slots.default.length !== 1) {
        console.error('[gd-tracker]: 只能包含一个子组件');
      }

      return this.$slots.default[0];
    }

    return null;
  },
  props: {
    debugMode: {
      type: Boolean,
      default: false
    },
    isProd: {
      type: Boolean,
      default: true
    },
    options: {
      type: Object,
      required: true
    },

    /**
     * tracker will be disabled
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    var _this = this;

    if (!this.options) throw new Error('options参数非法');

    if (this.disabled) {
      this.$tracker.trackerDisabled = true;
      return;
    }

    if (!this.$tracker._tracker.inited) {
      this.$tracker._tracker.setup(this.options, this.isProd, this.debugMode).then(function () {
        /**
         * 统计插件就绪事件
         *
         * @event ready:sensor
         */
        _this.$emit('ready:sensor');
      });
    } else {
      this.$emit('ready:sensor');
    }
  }
};

var bindEventIdVal = function bindEventIdVal(el, binding) {
  if (!binding.value) {
    return;
  }

  el.setAttribute('gdt-id', binding.value);
};
var bindEventId = function bindEventId(el, binding) {
  if (!binding.value) {
    return;
  }

  if (binding.value && binding.value.event_id) {
    el.setAttribute('gdt-id', binding.value.event_id);
  }

  if (binding.modifiers && Object.keys(binding.modifiers)[0]) {
    el.setAttribute('gdt-id', Object.keys(binding.modifiers)[0]);
  }
};

/**
 * 页面内元素点击统计
 *
 * @example
 * <a href="" v-gdt-click="computedLogData"></a>
 * <a href="" v-gdt-click="{sc_page: 'abc' ...}"></a>
 */

var vGdtClick = {
  bind: function bind(el, binding, vnode) {
    var context = vnode.context;
    var gdTracker = context.$tracker;
    context.__sensorClickTrack =
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var eventId, bindingValue, event, _event;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof binding.value === 'function')) {
                _context.next = 9;
                break;
              }

              eventId = Object.keys(binding.modifiers)[0];
              _context.next = 4;
              return binding.value();

            case 4:
              bindingValue = _context.sent;
              event = bindingValue.event;
              delete bindingValue.event;
              bindingValue.event_id = Number(eventId);
              gdTracker.invoke('trackEvent', event || 'click', bindingValue);

            case 9:
              if (_typeof(binding.value) === 'object') {
                // 如果返回false类类型则不记录
                _event = binding.value.event;
                delete binding.value.event;
                gdTracker.invoke('trackEvent', _event || 'click', binding.value);
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
    bindEventId(el, binding);
    el.addEventListener('click', context.__sensorClickTrack);
  },
  unbind: function unbind(el, binding, vnode) {
    if (!vnode.context) return;
    el.removeEventListener('click', vnode.context.__sensorClickTrack);
    delete vnode.context.__sensorClickTrack;
  },

  /**
   * vue3 适配
   * @param {*} el
   * @param {*} binding
   * @param {*} vnode
   */
  created: function created(el, binding, vnode) {
    var gdTracker = binding.instance.$tracker;

    vnode.__sensorClickTrack = function () {
      if (binding.value) {
        gdTracker.invoke('trackEvent', 'click', binding.value);
      }
    };

    bindEventId(el, binding);
    el.addEventListener('click', vnode.__sensorClickTrack);
  },

  /**
   * vue3 适配
   * @param {*} el
   * @param {*} binding
   * @param {*} vnode
   */
  beforeUnmount: function beforeUnmount(el, binding, vnode) {
    if (!vnode) return;
    el.removeEventListener('click', vnode.__sensorClickTrack);
    delete vnode.__sensorClickTrack;
  }
};

/** @directive v-gdt-expose */
// 神策曝光
// 当不能使用IntersectionObserver时，使用滚动事件来监听(只考虑垂直滚动)
// scrollEventHandlerMap存对应node的滚动事件handler
var scrollEventHandlerMap = new Map();

function isSameNode(source, target) {
  if (typeof source.isSameNode === 'function') {
    return source.isSameNode(target);
  }

  return source === target;
}
/**
 * calculateIntersection
 *
 * @desc 计算节点与根节点的交叉状态
 * @private
 *
 * @param sourceRect - 节点的boudingClientRect
 * @param rootRect - 根节点的boudingClientRect
 * @returns {Object}
 */


function calculateIntersection(sourceRect, rootRect) {
  var topDiff = rootRect.top - sourceRect.top;
  var ratio;

  if (topDiff > 0) {
    // 顶部超出容器顶部
    ratio = 1 - topDiff / sourceRect.height;
  } else {
    ratio = (rootRect.height + topDiff) / sourceRect.height;
  }

  var intersectionRatio = Math.min(Math.max(ratio, 0), 1);
  var isIntersecting = intersectionRatio > 0;
  return {
    intersectionRatio: intersectionRatio,
    isIntersecting: isIntersecting
  };
}
/**
 * observeDomIntersection
 *
 * @desc 监测某个节点与容器的接触状态（即是否在容器内可见）
 * @private
 * @param {Element} node - 被监听的dom节点
 * @param {Function} callback - 状态值更新时调用，回调参数: {
                    intersectionRatio,
                    isIntersecting,
                    boundingClientRect,
                    rootBounds,
                }
 * @param root=null - 不传则默认为document
 * @returns {Function} - 取消监测回调
 */


function observeDomIntersection(node, callback) {
  var root = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var scrollRoot = root || document; // 优先使用性能优化的IntersectionObserver

  var IntersectionObserver = window.IntersectionObserver;

  if (typeof IntersectionObserver === 'function') {
    var threshold = [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1];
    var options = {
      root: root,
      rootMargin: '0px',
      threshold: threshold
    };
    var observer = new IntersectionObserver(function intersectionCallback(entries) {
      entries.forEach(function (entry) {
        if (callback) {
          callback(entry);
        }
      });
    }, options);
    observer.observe(node);
    return function () {
      observer.unobserve(node);
    };
  } // 使用boundingClientRect计算


  var rootBounds;
  var scrollRootIsDocument = isSameNode(scrollRoot, document);

  if (scrollRootIsDocument) {
    rootBounds = {
      top: 0,
      left: 0,
      width: window.innerWidth,
      height: window.innerHeight
    };
  } else {
    rootBounds = scrollRoot.getBoundingClientRect();
  }

  var handler = function handler(e) {
    if (!scrollRootIsDocument) {
      // 非document节点可能会随着外部滚动改变clientRect值
      rootBounds = e.target.getBoundingClientRect();
    }

    var callbacks = scrollEventHandlerMap.get(e.target).callbacks;
    callbacks.forEach(function (_ref) {
      var node = _ref.node,
          callback = _ref.callback;
      var boundingClientRect = node.getBoundingClientRect();

      var _calculateIntersectio = calculateIntersection(boundingClientRect, rootBounds),
          intersectionRatio = _calculateIntersectio.intersectionRatio,
          isIntersecting = _calculateIntersectio.isIntersecting;

      if (callback) {
        // 返回部分关键的IntersectionObserver的返回数据结构
        // eslint-disable-next-line standard/no-callback-literal
        callback({
          intersectionRatio: intersectionRatio,
          isIntersecting: isIntersecting,
          boundingClientRect: boundingClientRect,
          rootBounds: rootBounds
        });
      }
    });
  };

  if (!scrollEventHandlerMap.has(scrollRoot)) {
    scrollRoot.addEventListener('scroll', handler);
    scrollEventHandlerMap.set(scrollRoot, {
      handler: handler,
      callbacks: [{
        node: node,
        callback: callback
      }]
    });
  } else {
    scrollEventHandlerMap.get(scrollRoot).callbacks.push({
      node: node,
      callback: callback
    });
  } // 渲染后第一次手动计算


  var boundingClientRect = node.getBoundingClientRect();

  var _calculateIntersectio2 = calculateIntersection(boundingClientRect, rootBounds),
      intersectionRatio = _calculateIntersectio2.intersectionRatio,
      isIntersecting = _calculateIntersectio2.isIntersecting;

  if (callback) {
    // 返回部分关键的IntersectionObserver的返回数据结构
    // eslint-disable-next-line standard/no-callback-literal
    callback({
      intersectionRatio: intersectionRatio,
      isIntersecting: isIntersecting,
      boundingClientRect: boundingClientRect,
      rootBounds: rootBounds
    });
  }

  return function () {
    var scrollEvent = scrollEventHandlerMap.get(scrollRoot);

    if (scrollEvent) {
      scrollEvent.callbacks = scrollEvent.callbacks.filter(function (cb) {
        return !isSameNode(cb.node, node);
      });

      if (scrollEvent.callbacks.length === 0) {
        scrollRoot.removeEventListener('scroll', scrollEvent.handler);
        scrollEventHandlerMap.delete(scrollRoot);
      }
    }
  };
}
/**
 * 页面内元素曝光统计，跟踪页面滚动行为
 *
 * @param {object} [options] - 曝光行为判定配置
 * @param {Boolean} [options.once=false] - 当前页面下是否只记录相应元素一次曝光，再次曝光不记录
 * @param {Number} [options.ratio=0] - 认定元素曝光需要的可视区域占比，默认0，即一进入视图内就认为已曝光
 * @param {Number} [options.minExposeTime=0] - 元素被认定曝光后，持续曝光多少ms后认定为一次有效曝光，默认0，即一认定曝光后即是有效
 *
 * @example
 * <div v-gdt-expose="sensorData">一进入就记录</div>
 * <div v-gdt-expose="{ options: {ratio: 0.5, once: true, minExposeTime: 0 }, ...sensorData}">
 * 进入大于一半后记录, 且在当前只记录一次
 * </div>
 * <div v-gdt-expose="{ options: {ratio: 0.5, minExposeTime: 2000 }, ...sensorLogData}">
 * 进入大于一半后并保持可见2s后记录
 * </div>
 */


var exposeTrack = function exposeTrack(el, binding, context, gdTracker) {
  if (!context.__scExpose) {
    context.__scExpose = new Map();
  }

  var exposeTrack = {};

  var bindingValue = _objectSpread({}, binding.value);

  var exposeOpts = Object.assign({}, {
    ratio: 0,
    once: false,
    minExposeTime: 0
  }, bindingValue.options);
  delete bindingValue.options; // 删除与神策无关数据

  var exposeTimer = null;

  exposeTrack.trackCb = function (_ref2) {
    var intersectionRatio = _ref2.intersectionRatio,
        isIntersecting = _ref2.isIntersecting;
    var ratioFullfilled = intersectionRatio > exposeOpts.ratio;
    var exposeRecorded = exposeTrack.exposeRecorded;
    var recordExposeThisTime = !exposeOpts.once || !exposeRecorded;
    var intersectingConditionFullfilled = isIntersecting && ratioFullfilled;

    if (intersectingConditionFullfilled && recordExposeThisTime) {
      if (!exposeTrack.exposedTimestamp || exposeTrack.exposedTimestamp === -1) {
        exposeTrack.exposedTimestamp = Date.now();
      }

      new Promise(function (resolve) {
        if (exposeOpts.minExposeTime > 0) {
          if (!exposeTimer) {
            exposeTimer = setTimeout(function () {
              if (exposeTrack.exposedTimestamp > -1) {
                resolve(true);
              } else {
                resolve(false);
              }
            }, exposeOpts.minExposeTime);
          }
        } else {
          resolve(true);
        }
      }).then(function (exposeTimeFullfiiled) {
        if (exposeTimeFullfiiled) {
          var event = bindingValue.event;
          delete bindingValue.event;
          gdTracker.invoke('trackEvent', event || 'expose', bindingValue);
          exposeTrack.exposeRecorded = true;
        }
      });
    } else if (!intersectingConditionFullfilled) {
      exposeTrack.exposedTimestamp = -1;
      clearTimeout(exposeTimer);
      exposeTimer = null;
    }
  }; // bind内绑定由于dom样式，scrollbar的位置未完全渲染完毕后执行，导致最初的判断是一直为true, 渲染完毕后为false
  // TODO: hack做法


  setTimeout(function () {
    exposeTrack.unobserve = observeDomIntersection(el, exposeTrack.trackCb);
  }, 300);

  context.__scExpose.set(el, exposeTrack);
};
var unbindExposeTrack = function unbindExposeTrack(el, context) {
  if (!context || !context.__scExpose) return;

  var exposeTrack = context.__scExpose.get(el);

  if (exposeTrack.unobserve) exposeTrack.unobserve();

  context.__scExpose.delete(el);

  if (context.__scExpose.size === 0) {
    delete context.__scExpose;
  }
};

/** @directive v-gdt-expose */
var vGdtExpose = {
  bind: function bind(el, binding, vnode) {
    if (!binding.value) {
      // 没有提供神策数据
      return;
    }

    var context = vnode.context;
    var gdTracker = context.$tracker;
    bindEventId(el, binding);
    exposeTrack(el, binding, context, gdTracker);
  },
  unbind: function unbind(el, binding, vnode) {
    var context = vnode.context;
    unbindExposeTrack(el, context);
  },

  /**
   * vue3 适配
   * @param {*} el
   * @param {*} binding
   * @param {*} vnode
   */
  created: function created(el, binding, vnode) {
    if (!binding.value) {
      // 没有提供神策数据
      return;
    }

    var gdTracker = binding.instance.$tracker;
    bindEventId(el, binding);
    exposeTrack(el, binding, vnode, gdTracker);
  },

  /**
   * vue3 适配
   * @param {*} el
   * @param {*} binding
   * @param {*} vnode
   */
  beforeUnmount: function beforeUnmount(el, binding, vnode) {
    unbindExposeTrack(el, vnode);
  }
};

var hoverTrack = function hoverTrack(el, binding, context, gdTracker) {
  if (!context.__hoverTrack) {
    context.__hoverTrack = new Map();
  }

  var hoverTrack = {};

  var bindingValue = _objectSpread({}, binding.value);

  var hoverOpts = Object.assign({}, {
    mouseOverCb: function mouseOverCb() {
      return true;
    },
    mouseLeaveCb: function mouseLeaveCb() {}
  }, bindingValue.options);
  delete bindingValue.options; // 删除与神策无关数据

  hoverTrack.mouseOverTrack = function () {
    if (!hoverTrack.mouseInside) {
      hoverTrack.mouseInside = true; // 防止内部移动鼠标触发多次track

      Promise.resolve(true).then(function () {
        return hoverOpts.mouseOverCb();
      }).then(function (canTrack) {
        if (canTrack) {
          gdTracker.invoke('trackEvent', 'expose', bindingValue);
        }
      });
    }
  };

  hoverTrack.mouseLeaveTrack = function () {
    hoverTrack.mouseInside = false;
    hoverOpts.mouseLeaveCb();
  };

  el.addEventListener('mouseover', hoverTrack.mouseOverTrack);
  el.addEventListener('mouseleave', hoverTrack.mouseLeaveTrack);

  context.__hoverTrack.set(el, hoverTrack);
};

var unHoverTrack = function unHoverTrack(el, context) {
  var hoverTrack = context.__hoverTrack.get(el);

  el.removeEventListener('mouseover', hoverTrack.mouseOverTrack);
  el.removeEventListener('mouseleave', hoverTrack.mouseLeaveTrack);

  context.__hoverTrack.delete(el);

  if (context.__hoverTrack.size === 0) {
    delete context.__hoverTrack;
  }
};

var vGdtHover = {
  bind: function bind(el, binding, vnode) {
    if (!binding.value) {
      // 没有提供神策数据
      return;
    }

    var context = vnode.context;
    var gdTracker = context.$tracker;
    bindEventId(el, binding);
    hoverTrack(el, binding, context, gdTracker);
  },
  unbind: function unbind(el, binding, vnode) {
    var context = vnode.context;
    if (!context) return;
    unHoverTrack(el, context);
  },

  /**
   * vue3 适配
   * @param {*} el
   * @param {*} binding
   * @param {*} vnode
   */
  created: function created(el, binding, vnode) {
    if (!binding.value) {
      // 没有提供神策数据
      return;
    }

    var gdTracker = binding.instance.$tracker;
    bindEventId(el, binding);
    hoverTrack(el, binding, vnode, gdTracker);
  },

  /**
   * vue3 适配
   * @param {*} el
   * @param {*} binding
   * @param {*} vnode
   */
  beforeUnmount: function beforeUnmount(el, binding, vnode) {
    unHoverTrack(el, vnode);
  }
};

/**
 * 素材模板曝光
 * 1、在屏幕展示大于等于2/3被曝光对象；
 * 2、在屏幕的停留时间大于等于1.5秒；
 * 3、一个页面对于同一个内容仅曝光一次。仅当重新进入页面后会继续上报。
 */
var materialExpose = {
  event_id: EVENT_ID.material_expose,
  event: 'material_expose',
  options: {
    ratio: 0.666,
    // 认定元素曝光需要的可视区域占比，默认0，即一进入视图内就认为已曝光
    once: true,
    // 当前页面下是否只记录相应元素一次曝光，再次曝光不记录
    minExposeTime: 1500 // 元素被认定曝光后，持续曝光多少ms后认定为一次有效曝光，默认0，即一认定曝光后即是有效

  }
};
var vGdtExposeMaterial = {
  bind: function bind(el, binding, vnode) {
    if (!binding.value) {
      binding.value = {};
    }

    binding.value = Object.assign(INIT_EVENT_DETAILS.material_expose, binding.value, materialExpose);
    var context = vnode.context;
    var gdTracker = context.$tracker;
    bindEventId(el, binding);
    exposeTrack(el, binding, context, gdTracker);
  },
  unbind: function unbind(el, binding, vnode) {
    var context = vnode.context;
    unbindExposeTrack(el, context);
  },

  /**
   * vue3 适配
   * @param {*} el
   * @param {*} binding
   * @param {*} vnode
   */
  created: function created(el, binding, vnode) {
    if (!binding.value) {
      // 没有提供神策数据
      return;
    }

    var gdTracker = binding.instance.$tracker;
    bindEventId(el, binding);
    exposeTrack(el, binding, vnode, gdTracker);
  },

  /**
   * vue3 适配
   * @param {*} el
   * @param {*} binding
   * @param {*} vnode
   */
  beforeUnmount: function beforeUnmount(el, binding, vnode) {
    unbindExposeTrack(el, vnode);
  }
};

/**
 * 资源位曝光时触发上报
 * 1、一展示就曝光
 * 2、再次展示再次曝光
 */
var materialExpose$1 = {
  event_id: EVENT_ID.resource_loc_expose,
  event: 'resource_loc_expose',
  options: {
    ratio: 0,
    // 认定元素曝光需要的可视区域占比，默认0，即一进入视图内就认为已曝光
    once: false,
    // 当前页面下是否只记录相应元素一次曝光，再次曝光不记录
    minExposeTime: 0 // 元素被认定曝光后，持续曝光多少ms后认定为一次有效曝光，默认0，即一认定曝光后即是有效

  }
};
var vGdtExposeResoureLoc = {
  bind: function bind(el, binding, vnode) {
    if (!binding.value) {
      binding.value = {};
    }

    binding.value = Object.assign(INIT_EVENT_DETAILS.resource_loc_expose, binding.value, materialExpose$1);
    var context = vnode.context;
    var gdTracker = context.$tracker;
    bindEventId(el, binding);
    exposeTrack(el, binding, context, gdTracker);
  },
  unbind: function unbind(el, binding, vnode) {
    var context = vnode.context;
    unbindExposeTrack(el, context);
  },

  /**
   * vue3 适配
   * @param {*} el
   * @param {*} binding
   * @param {*} vnode
   */
  created: function created(el, binding, vnode) {
    if (!binding.value) {
      // 没有提供神策数据
      return;
    }

    var gdTracker = binding.instance.$tracker;
    bindEventId(el, binding);
    exposeTrack(el, binding, vnode, gdTracker);
  },

  /**
   * vue3 适配
   * @param {*} el
   * @param {*} binding
   * @param {*} vnode
   */
  beforeUnmount: function beforeUnmount(el, binding, vnode) {
    unbindExposeTrack(el, vnode);
  }
};

/** @directive v-gdt-id */
var vGdtId = {
  bind: function bind(el, binding) {
    bindEventIdVal(el, binding);
  },

  /**
   * vue3 适配
   * @param {*} el
   * @param {*} binding
   */
  created: function created(el, binding) {
    bindEventIdVal(el, binding);
  }
};

/**
 * utils/promise-map
 *
 * @description promise map method with native Promise.
 * @author yunlu
 *
 * @param {Array} items iterator.
 * @param {Function} mapper function(any item, int index, int length)
 */
var promiseMap = function promiseMap(items, mapper) {
  var promises = items.map(function (item) {
    return Promise.resolve(mapper(item, items.indexOf(item), items.length));
  });
  return Promise.all(promises);
};

var cache = [];
function genScript(url) {
  if (cache.indexOf(url) > -1) return Promise.resolve();
  var index = cache.length;
  cache.push(url);
  var script = document.createElement('script');
  return new Promise(function (resolve, reject) {
    script.onload = resolve;

    script.onerror = function (error) {
      cache.splice(index, 1);
      reject(error);
    };

    script.src = url;
    var firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);
  });
}

var trackerHMT = {
  name: '_hmt',

  /**
   * @function
   * @name setup
   * @description 注入统计脚本
   *
   * @param {Object} options - 统计脚本参数
   * @param {Boolean} [isProd=false] - 是否生产环境。生产环境下使用调试模式，DevTools Console 会发出警告。
   * @param {Boolean} [debug=false] - 是否调试模式。优先使用 options.debug 参数。
   * @param {String} [options.projectId = '123'] - 统计工具项目 ID。
   *
   * @returns {Promise}
   */
  setup: function setup() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        projectId = _ref.projectId;

    var isProd = arguments.length > 1 ? arguments[1] : undefined;
    var debug = arguments.length > 2 ? arguments[2] : undefined;

    if (!isProd && !debug) {
      return;
    }

    if (!window._hmt) {
      window._hmt = [];
    } // // close auto pv
    // 百度 _trackPageview 会导致 来源丢失，暂时先开启自动 PV
    // window._hmt.push(['_setAutoPageview', false]);
    // 因开启百度自动 PV，页面首次载入时会自动记录一次 PV，此处记录方便后续去重
    // relative path


    trackerHMT.lastPvPath = document.URL.replace(document.location.origin, ''); // return $.getScript(`https://hm.baidu.com/hm.js?${projectId}`);

    return genScript("https://hm.baidu.com/hm.js?".concat(projectId)).then(function () {
      if (debug) {
        console.log('_hmt setup finished');
      }
    });
  },

  /**
   * @function
   * @name login
   * @description 关联用户 ID，设置用户属性
   *
   * @param {Number|Object} [userId] - 用户 ID | 用户信息
   * @param {Object} [profiles] - 直接设置的用户属性，如果存在则覆盖。
   * @param {*|Function} [profiles.key] - 用户属性 key 对应的值，支持函数或值。
   * @param {Array} [keyMap] - 指定 profiles key 对应的 tag。对百度生效。
   * @param {String} [keyMap.key] - profiles key 对应的 tag。对百度生效。
   */
  login: function login(userId, profiles, onceProfiles) {
    var keyMap = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var _window = window,
        _hmt = _window._hmt;

    if (!_hmt) {
      return;
    }

    var setUserTag = function setUserTag(key, value) {
      var tagKey = keyMap[key];

      if (tagKey) {
        _hmt.push(['_setUserTag', key, value]);
      }
    };

    if (userId) {
      setUserTag('id', userId);
    } // profiles


    if (profiles && Object.keys(profiles)) {
      var _arr = Object.keys(profiles);

      for (var _i = 0; _i < _arr.length; _i++) {
        var key = _arr[_i];
        var profile = profiles[key];
        var value = typeof profile === 'function' ? profile() : profile;

        if (value !== undefined) {
          setUserTag(key, value);
        }
      }
    }
  },

  /**
   * @function
   * @name logout
   * @description 取消关联用户 ID。百度统计暂不支持。
   *
   * @deprecated 百度统计暂不支持取消关联用户 ID。
   */
  logout: function logout() {},

  /**
   *
   * @function
   * @name trackPageView
   * @description 上报 PV
   *
   * @param {String} [path] - 当前地址。请使用相对路径。对于首屏访问的 PV，需要传入相对路径以避免与自动 PV 重复。
   * @param {String} [referrer] - 前向地址。请使用绝对路径。
   */
  trackPageView: function trackPageView(path) {
    var referrer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var _window2 = window,
        _hmt = _window2._hmt; // 检查初始化以及过滤重复 pv

    if (!_hmt || path === trackerHMT.lastPvPath) {
      return;
    }

    _hmt.push(['_trackPageview', path, referrer]);

    trackerHMT.lastPvPath = path;
  },

  /**
   * @function
   * @name trackEvent
   * @description 上报自定义事件。目前仅支持神策自定义事件埋点。
   *
   * @param {String} eventName - 事件名
   * @param {Object} [properties] - 事件属性
   * @param {*} [properties.key] - 事件属性 key 对应的值，暂不支持函数。值为 undefined 时不进行上报。
   */
  // https://tongji.baidu.com/web/25104977/custom/event_track?siteId=11682592
  trackEvent: function trackEvent(eventName, properties) {
    var _window3 = window,
        _hmt = _window3._hmt;

    if (!_hmt) {
      return;
    }

    var data = [eventName];

    if (properties) {
      var _arr2 = Object.keys(properties);

      for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
        var key = _arr2[_i2];
        var value = properties[key];

        if (Array.isArray(value)) {
          data.push.apply(data, _toConsumableArray(value));
        } else {
          data.push(value);
        }
      }
    }

    _hmt.push(['_trackEvent'].concat(data));
  }
};

function objToFormData(obj) {
  var formData = new FormData();

  for (var key in obj) {
    formData.append(key, obj[key]);
  }

  return formData;
}

function send(url, data) {
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  if (canIUse()) {
    var success = window.navigator.sendBeacon(url, objToFormData(data));
    setTimeout(function () {
      callback(success ? null : new Error('Send beacon fail.'));
    }, 0);
    return success;
  } else {
    return false;
  }
}

function canIUse() {
  return !!window.navigator.sendBeacon;
}

var beacon = {
  send: send
};

function stringify(obj) {
  var sep = '&';
  var eq = '=';
  return Object.keys(obj).map(function (key) {
    return "".concat(encodeURIComponent(key)).concat(eq).concat(encodeURIComponent(obj[key]));
  }).join(sep);
}

var qs = {
  stringify: stringify
};

function send$1(url, data) {
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var key = "__IMAGE_BEACON__".concat(Date.now());
  var img = new Image();
  var resolvedUrl = url + '?' + qs.stringify(data);
  window[key] = img;

  img.onload = function () {
    callback(null);
    delete window[key];
  };

  img.onerror = img.onabort = function (e) {
    callback(e);
    delete window[key];
  };

  img.src = resolvedUrl;
  return true;
}

var image = {
  send: send$1
};

function send$2(url, data) {
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var xhr = new XMLHttpRequest();
  xhr.open('POST', url, true);

  xhr.onreadystatechange = function () {
    if (xhr.readyState !== 4) {
      return;
    }

    var status = xhr.status;
    var error = null;

    if (status < 200 || status >= 400) {
      error = new Error('Network error.');
    }

    callback(error);
  };

  var body = objToFormData(data);
  xhr.send(body);
  return true;
}

var xhr = {
  send: send$2
};

var UA_BLACKLIST = [/BingPreview/i, /bingbot/i, /Bytespider/i];
/**
 * 上报数据。
 * @param {string} url 请求地址。
 * @param {Object} data 发送的数据。
 * @param {*} callback 成功或者失败回调。
 * @param {'beacon'|'image'|'xhr'} [transport= ''] 上报机制。
 */

function request(url, data, callback) {
  var transport = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var ua = window.navigator.userAgent;
  var sendable = canSend(ua);

  if (!sendable) {
    return;
  }

  if (isPrivate()) {
    return;
  }

  var send = null;

  switch (transport) {
    case 'beacon':
      send = beacon.send;
      break;

    case 'image':
      send = image.send;
      break;

    case 'xhr':
      send = xhr.send;
      break;

    default:
      send = smartSend;
  }

  send(url, data, callback);
}

function canSend(ua) {
  return UA_BLACKLIST.every(function (i) {
    return !i.test(ua);
  });
}

function isPrivate() {
  return window._IS_PRIVATE_;
}

function smartSend(url, data, callback) {
  return beacon.send(url, data, callback) || image.send(url, data, callback) || xhr.send(url, data, callback);
}

function UUID() {
  var e = function e() {
    for (var e = 1 * new Date(), t = 0; e === 1 * new Date();) {
      t++;
    }

    return e.toString(16) + t.toString(16);
  };

  var t = function t() {
    return Math.random().toString(16).replace('.', '');
  };

  var r = function r(e) {
    function t(e, t) {
      var r;
      var n = 0;

      for (r = 0; r < t.length; r++) {
        n |= a[r] << 8 * r;
      }

      return e ^ n;
    }

    var r;
    var n;
    var s = navigator.userAgent;
    var a = [];
    var i = 0;

    for (r = 0; r < s.length; r++) {
      n = s.charCodeAt(r);
      a.unshift(255 & n);

      if (a.length >= 4) {
        i = t(i, a);
        a = [];
      }
    }

    a.length > 0 && (i = t(i, a));
    return i.toString(16);
  };

  return function () {
    var n = String(screen.height * screen.width);
    n = n && /\d{5,}/.test(n) ? n.toString(16) : String(31242 * Math.random()).replace('.', '').slice(0, 8);
    var s = e() + '-' + t() + '-' + r() + '-' + n + '-' + e();
    return s;
  };
}

var UUID$1 = UUID();

/**
 * 支持 Unicode 的 base64 encode。
 * @param {string} input 目标字符串
 * @return {string}
 */
function base64encode(input) {
  var UTF8Input = strToUTF8Arr(input);
  return base64EncArr(UTF8Input);
}
/* Base64 string to array encoding */

function uint6ToB64(nUint6) {
  return nUint6 < 26 ? nUint6 + 65 : nUint6 < 52 ? nUint6 + 71 : nUint6 < 62 ? nUint6 - 4 : nUint6 === 62 ? 43 : nUint6 === 63 ? 47 : 65;
}

function base64EncArr(aBytes) {
  var eqLen = (3 - aBytes.length % 3) % 3;
  var sB64Enc = '';

  for (var nMod3, nLen = aBytes.length, nUint24 = 0, nIdx = 0; nIdx < nLen; nIdx++) {
    nMod3 = nIdx % 3;
    /* Uncomment the following line in order to split the output in lines 76-character long: */

    /*
    if (nIdx > 0 && (nIdx * 4 / 3) % 76 === 0) { sB64Enc += "\r\n"; }
    */

    nUint24 |= aBytes[nIdx] << (16 >>> nMod3 & 24);

    if (nMod3 === 2 || aBytes.length - nIdx === 1) {
      sB64Enc += String.fromCharCode(uint6ToB64(nUint24 >>> 18 & 63), uint6ToB64(nUint24 >>> 12 & 63), uint6ToB64(nUint24 >>> 6 & 63), uint6ToB64(nUint24 & 63));
      nUint24 = 0;
    }
  }

  return eqLen === 0 ? sB64Enc : sB64Enc.substring(0, sB64Enc.length - eqLen) + (eqLen === 1 ? '=' : '==');
}
/* DOMString to UTF-8 array */


function strToUTF8Arr(sDOMStr) {
  var aBytes;
  var nChr;
  var nStrLen = sDOMStr.length;
  var nArrLen = 0;
  /* mapping... */

  for (var nMapIdx = 0; nMapIdx < nStrLen; nMapIdx++) {
    nChr = sDOMStr.charCodeAt(nMapIdx);
    nArrLen += nChr < 0x80 ? 1 : nChr < 0x800 ? 2 : nChr < 0x10000 ? 3 : nChr < 0x200000 ? 4 : nChr < 0x4000000 ? 5 : 6;
  }

  aBytes = new Uint8Array(nArrLen);
  /* transcription... */

  for (var nIdx = 0, nChrIdx = 0; nIdx < nArrLen; nChrIdx++) {
    nChr = sDOMStr.charCodeAt(nChrIdx);

    if (nChr < 128) {
      /* one byte */
      aBytes[nIdx++] = nChr;
    } else if (nChr < 0x800) {
      /* two bytes */
      aBytes[nIdx++] = 192 + (nChr >>> 6);
      aBytes[nIdx++] = 128 + (nChr & 63);
    } else if (nChr < 0x10000) {
      /* three bytes */
      aBytes[nIdx++] = 224 + (nChr >>> 12);
      aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
      aBytes[nIdx++] = 128 + (nChr & 63);
    } else if (nChr < 0x200000) {
      /* four bytes */
      aBytes[nIdx++] = 240 + (nChr >>> 18);
      aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
      aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
      aBytes[nIdx++] = 128 + (nChr & 63);
    } else if (nChr < 0x4000000) {
      /* five bytes */
      aBytes[nIdx++] = 248 + (nChr >>> 24);
      aBytes[nIdx++] = 128 + (nChr >>> 18 & 63);
      aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
      aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
      aBytes[nIdx++] = 128 + (nChr & 63);
    } else
      /* if (nChr <= 0x7fffffff) */
      {
        /* six bytes */
        aBytes[nIdx++] = 252 + (nChr >>> 30);
        aBytes[nIdx++] = 128 + (nChr >>> 24 & 63);
        aBytes[nIdx++] = 128 + (nChr >>> 18 & 63);
        aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
        aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
        aBytes[nIdx++] = 128 + (nChr & 63);
      }
  }

  return aBytes;
}

/**
 * 无垠数据层级类型。
 * @typedef {('basic'|'common'|'event')} Scope
 * @see {@link SCOPE}
 */

/**
 * 无垠数据层级枚举。
 * @enum {Scope}
 * @readonly
 */

var SCOPE = {
  /** 基础公共数据层 */
  basic: 'basic',

  /** 公共业务数据层 */
  common: 'common',

  /** 业务事件数据层 */
  event: 'event'
};
/**
 * 时区偏移量
 * @returns string
 */

var getTimezoneOffset = function getTimezoneOffset() {
  var offset = new Date().getTimezoneOffset();
  var operator = offset >= 0 ? '-' : '+';

  var _offset = Math.abs(offset);

  var h = Math.floor(_offset / 60);
  var m = Math.floor(_offset % 60);

  var _h = h < 10 ? "0".concat(h) : h;

  var _m = m < 10 ? "0".concat(m) : m;

  return "".concat(operator).concat(_h, ":").concat(_m);
};
/**
 * 获取 UTC 时间+时区偏移量
 * @param {number}} now
 * @returns string
 */


var getUTCTime = function getUTCTime(now) {
  var utc = new Date(now).toISOString();
  return utc.replace('Z', getTimezoneOffset());
};
/**
 * 代表无垠数据的类。
 * @see {@link https://doc.huanleguang.com/pages/viewpage.action?pageId=43206813|无垠数据-数据格式概览}
 */


var Store =
/*#__PURE__*/
function () {
  /**
   * {@link https://doc.huanleguang.com/pages/viewpage.action?pageId=43206823|无垠数据-基础公共数据层}
   * @type {Object}
   * @private
   */

  /**
   * {@link https://doc.huanleguang.com/pages/viewpage.action?pageId=43206834|无垠数据-公共业务数据层}
   * @type {Object}
   * @private
   */

  /**
   * {@link https://doc.huanleguang.com/pages/viewpage.action?pageId=43206841|无垠数据-业务事件数据层}
   * @type {Object}
   * @private
   */

  /**
   * 创建无垠数据类。
   * @param {!Object} [basicFields={}] 初始无垠数据基础公共数据。
   * @param {!Object} [commonFields={}] 初始无垠数据公共业务数据。
   * @param {!Object} [eventFields={}] 初始无垠数据业务事件数据。
   */
  function Store(basicFields, commonFields, eventFields) {
    _classCallCheck(this, Store);

    _defineProperty(this, "basicFields", null);

    _defineProperty(this, "commonFields", null);

    _defineProperty(this, "eventFields", null);

    this.basicFields = basicFields;
    this.commonFields = commonFields;
    this.eventFields = eventFields;
  }
  /**
   * 设置对应层级的无垠数据。
   * 如果字段存在则覆盖。
   * @param {Scope} scope 无垠数据层级。
   * @param {!Object} fieldsObject 无垠数据字段对象。
   */


  _createClass(Store, [{
    key: "set",
    value: function set(scope, fieldsObject) {
      if (!SCOPE[scope]) {
        error('parameter "scope" is required.');
        return;
      }

      var key = "".concat(scope, "Fields");

      for (var field in fieldsObject) {
        var fieldValue = fieldsObject[field];

        if ([undefined, null, NaN].includes(fieldValue)) {
          this[key][field] && delete this[key][field];
        } else {
          this[key][field] = fieldValue;
        }
      }
    }
    /**
     * 获取对应层级的无垠数据。
     * 如果没有传入 fields 参数，默认返回 scope 指定的所有数据，否则返回包含 fields 的字段对象。
     * 若 field 不存在，则不返回该 field 指定的字段值。
     * @param {Scope} scope 无垠数据层级。
     * @param  {...string} [fields] 待获取的字段。
     * @return {!Object}
     */

  }, {
    key: "get",
    value: function get(scope) {
      for (var _len = arguments.length, fields = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      if (!SCOPE[scope]) {
        error('parameter "scope" is required.');
        return;
      }

      var key = "".concat(scope, "Fields");
      var scopeFields = this[key];

      if (!fields || !fields.length) {
        return _objectSpread({}, scopeFields);
      }

      return Object.keys(scopeFields).reduce(function (fieldsObject, key) {
        if (fields.includes(key)) {
          fieldsObject[key] = scopeFields[key]; // 浅拷贝
        }

        return fieldsObject;
      }, {});
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var basicFields = this.get('basic');
      var commonFields = this.get('common');
      var eventFields = this.get('event');
      var now = Date.now();
      var utc = getUTCTime(now);
      var data = basicFields;
      basicFields.report_time = now;
      basicFields.data = commonFields;
      commonFields.attributes = eventFields;
      commonFields.timestamp = now;
      commonFields.utc_time = utc;
      return data;
    }
  }, {
    key: "clone",
    value: function clone() {
      var basicFields = this.get('basic');
      var commonFields = this.get('common');
      var eventFields = this.get('event');
      return new Store(basicFields, commonFields, eventFields);
    }
  }]);

  return Store;
}();
/**
 * 创建无垠数据类。
 * @param {!Object} [basicFields={}] 初始无垠数据基础公共数据。
 * @param {!Object} [commonFields={}] 初始无垠数据公共业务数据。
 * @param {!Object} [eventFields={}] 初始无垠数据业务事件数据。
 * @return {Store}
 */


function createStore(basicFields, commonFields, eventFields) {
  return new Store(basicFields, commonFields, eventFields);
}

/**
 * 浏览器判断
 */
var isIEBrowser = function isIEBrowser() {
  if ((typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) !== 'object') {
    return false;
  }

  var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串

  var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1; // 判断是否IE<11浏览器

  var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
  return isIE || isIE11;
};

var SCHEMA_URL = 'https://schema-manager.hlgdata.com/index.html#/schema/list/detail/'; // const FIX_EVENT_DOC = 'http://doc.fe.gaoding.com/gd-tracker/sdk/web-sdk.html#api-%E5%9B%BA%E5%8C%96%E4%BA%8B%E4%BB%B6';
// const FIX_EVENT_IDS = Object.values(EVENT_ID);

var TYPE_MAP = {
  string: 'string',
  number: 'number',
  boolean: 'boolean',
  long: 'number',
  integer: 'number',
  'array/string': 'object',
  'array/integer': 'object'
};

function isString(val) {
  return typeof val === 'string';
}

function isNumber(val) {
  return typeof val === 'number';
} // function isArray(val) {
//     return Object.prototype.toString.apply(val) === '[object Array]';
// }


function validateCommon(common) {
  var flag = false;
  var event = common.event,
      event_id = common.event_id,
      user_id = common.user_id,
      is_login = common.is_login;

  if (!isString(event) || !event) {
    warn("\u57CB\u70B9\u4E8B\u4EF6 ".concat(event_id, " event \u5B57\u6BB5\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u6216\u7C7B\u578B\u6709\u8BEF\uFF0C\u671F\u5F85\u7C7B\u578B string\uFF0C\u627E\u5230\u7C7B\u578B ").concat(_typeof(event)));
    flag = true;
  }

  if (!isNumber(event_id)) {
    warn("\u57CB\u70B9\u4E8B\u4EF6 ".concat(event_id, " event_id \u5B57\u6BB5\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u6216\u7C7B\u578B\u6709\u8BEF\uFF0C\u671F\u5F85\u7C7B\u578B number ").concat(_typeof(event_id)));
    flag = true;
  }

  if (!isString(user_id) || !user_id) {
    warn("\u57CB\u70B9\u4E8B\u4EF6 ".concat(event_id, " user_id \u5B57\u6BB5\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u6216\u7C7B\u578B\u6709\u8BEF\uFF0C\u671F\u5F85\u7C7B\u578B string\uFF0C\u627E\u5230\u7C7B\u578B ").concat(_typeof(user_id)));
    flag = true;
  }

  if (!isNumber(is_login)) {
    warn("\u57CB\u70B9\u4E8B\u4EF6 ".concat(event_id, " is_login \u5B57\u6BB5\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u6216\u7C7B\u578B\u6709\u8BEF\uFF0C\u671F\u5F85\u7C7B\u578B number\uFF0C\u627E\u5230\u7C7B\u578B ").concat(_typeof(is_login)));
    flag = true;
  }

  return flag;
}

function validateEvent(store) {
  if (!window.GDT_WIND_SCHEMA) {
    return;
  }

  var _store$get = store.get('event'),
      detail = _store$get.detail;

  if (!detail) {
    return;
  }

  var _store$get2 = store.get('common'),
      event_id = _store$get2.event_id;

  var eventSchema = window.GDT_WIND_SCHEMA.find(function (item) {
    return item.id === event_id;
  });

  if (!eventSchema) {
    return;
  } // const isFixEventId = FIX_EVENT_IDS.includes(Number(event_id));


  var eventName = eventSchema.n;
  var schemaId = eventSchema.iid;
  eventSchema.d.forEach(function (item) {
    var isRequired = item.rq;
    var type = item.tp; // if(isFixEventId && (typeof detail !== 'object' || !detail.hasOwnProperty(item.fn))) {
    //     warn(`埋点事件 ${eventName}: ${event_id} 缺少 ${item.fn} 字段。建议使用固化事件 ${FIX_EVENT_DOC}`);
    //     return;
    // }

    if (isRequired && !detail[item.fn] && detail[item.fn] !== 0) {
      warn("\u57CB\u70B9\u4E8B\u4EF6 ".concat(eventName, ": ").concat(event_id, "\u3010\u5FC5\u586B\u3011\u5B57\u6BB5 ").concat(item.fn, " \u4E3A\u7A7A\u3002\u67E5\u770B\u8BE6\u60C5 ").concat(SCHEMA_URL).concat(schemaId));
      return;
    } // eslint-disable-next-line valid-typeof


    if (typeof detail[item.fn] !== 'undefined' && _typeof(detail[item.fn]) !== TYPE_MAP[type]) {
      warn("\u57CB\u70B9\u4E8B\u4EF6 ".concat(eventName, ": ").concat(event_id, " \u5B57\u6BB5 ").concat(item.fn, " \u7C7B\u578B\u6709\u8BEF\uFF0C\u671F\u5F85\u7C7B\u578B ").concat(TYPE_MAP[type], "\uFF0C\u627E\u5230\u7C7B\u578B ").concat(_typeof(detail[item.fn]), "\u3002\u67E5\u770B\u8BE6\u60C5 ").concat(SCHEMA_URL).concat(schemaId));
    }
  });
}

function validate(store) {
  var common = store.get('common');

  if (common && common.env === 'prod') {
    return;
  }

  validateEvent(store);
  return validateCommon(common);
}

var DEFAULT_SERVER_HOST = 'https://wind.hlgdata.com';
var SDK_VERSION = "1.16.0";
var PATH = '/wind'; // 数据上报渠道路径

var DEFAULT_COORDINATES = {
  region_id: '1',
  biz_code: '1',
  endpoint: '4'
};
var PLUGINS = {
  'abtest-data-tracker': ABTestDataTracker,
  'utm-data-tracker': UtmDataTracker,
  'router-change-tracker': RouterChangeTracker,
  'page-duration-tracker': PageDurationTracker
};
/**
 * 无垠数据层级对象。
 * @typedef {Object.<module:trackers/wind/store~Scope, Object>} ScopeObject
 * @global
 */

/**
 * 无垠数据跟踪器类。
 */

var WindTracker =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(WindTracker, _EventEmitter);

  /**
   * 数据接收地址。
   * @type {string}
   */

  /**
   * 上报机制。
   * @type {string}
   */

  /**
   * 是否显示 log 信息。
   * @type {boolean}
   */

  /**
   * 调试模式。
   * @type {boolean}
   */

  /**
   * 是否需要登录。
   * @type {boolean}
   */

  /**
   * 登录标识。
   * @type {boolean}
   */

  /**
   * 无垠数据类实例。
   * @type {module:trackers/wind/store~Store}
   * @private
   */

  /**
   * 已安装插件集合。
   * @type {Object.<string, TrackPluginInstance>}
   */

  /**
   * beforeEach 钩子函数集合。
   * @type {Function[]}
   */

  /**
   * 登录队列。
   * @type {Fucntion[]}
   */

  /**
   * 定时器
   */

  /**
   * 定义时间 (ms)
   * @type {Number}
   */

  /**
   * 定义数据条数
   * @type {Number}
   */

  /**
   * 定义数据队列
   * @type {Array}
   */

  /**
   * 初始化无垠数据。
   * @param {Object} options 配置选项
   * @param {string} [options.serverUrl] 数据接收地址。没有该参数时，可通过参数 serverHost 和 debug 自动生成。
   * @param {string} [options.serverHost = 'https://wind.hlgdata.com'] 数据接收域名。用于生成数据接收地址，优先使用 serverUrl 参数。
   * @param {string} options.project 项目名，无垠数据基础公共数据字段。
   * @param {string} options.version 项目版本，无垠数据公共业务数据字段。
   * @param {('env'|'stage'|'prod')} options.env 事件环境，无垠数据公共业务数据字段。
   * @param {Object} [options.coordinates] 坐标信息
   * @param {string} [options.coordinates.region_id='1'] 地区
   * @param {string} [options.coordinates.biz_code='1'] 产品线
   * @param {string} [options.coordinates.endpoint='4'] 用户端
   * @param {[string, Object][]} [options.plugins] 插件列表
   * @param {'beacon'|'image'|'xhr'} [options.transport] 上报机制。
   * @param {boolean} [options.login=false] 是否需要登录后才上报数据。
   * @param {boolean} [options.showLog=false] 是否显示 log 信息。
   * @param {boolean} [options.debug=false] - 调试模式。 用于生成数据接收地址，优先使用 serverUrl 参数。
   * @param {boolean} [isProd=false] 是否生产环境，生产环境下使用调试模式，DevTools Console 会发出警告。
   * @param {boolean} [debug=false] 是否调试模式，优先使用 options.debug 参数。
   * @param {boolean} [batch=false] 是否批量上报埋点数据
   */
  function WindTracker(options) {
    var _this;

    var isProd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var debug = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, WindTracker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindTracker).call(this));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "serverUrl", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "transport", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "showLog", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "debug", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "needLogin", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isLogin", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "store", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "installedPlugins", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "beforeEachFns", []);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "loginQueue", []);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "sendTimer", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "sendTime", 5000);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "sendCount", 10);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "sendQueue", []);

    debug = _this.debug = options.debug || debug;

    if (!options.serverUrl) {
      var project = options.project;
      var serverHost = options.serverHost || DEFAULT_SERVER_HOST;

      if (!project) {
        throw new Error('Required Params: serveUrl OR project.');
      }

      if (isProd && debug) {
        warn('You are using debug mode in PRODUCTION!');
      }

      options.serverUrl = "".concat(serverHost, "/wind").concat(debug ? '/debug' : '');
    }

    _this.needLogin = !!options.login;
    _this.showLog = options.showLog;
    _this.serverUrl = options.serverUrl;
    _this.transport = options.transport || '';
    _this.batch = !!options.batch && !isIEBrowser(); // IE 下不支持批量上报

    var coordinates = Object.keys(DEFAULT_COORDINATES).reduce(function (coords, coord) {
      coords[coord] = options.coordinates && options.coordinates[coord] && String(options.coordinates[coord]) || DEFAULT_COORDINATES[coord];
      return coords;
    }, {}); // 初始化无垠数据

    var basicFields = {
      project: options.project,
      path: PATH,
      sdk_version: SDK_VERSION,
      runtime: _this.getRuntime()
    };
    var commonFields = {
      // FIXME: is_first_day 逻辑依赖于 device_id，必须先于 getDeviceId。
      device_id: _this.getDeviceId(),
      is_first_day: _this.getIsFirstDay(),
      project_ver: options.version,
      session_id: _this.getSessionId(),
      env: options.env,
      user_id: '',
      is_login: 0,
      referrer: _this.getReferrer()
    };

    var eventFields = _objectSpread({}, coordinates);

    _this.store = createStore(basicFields, commonFields, eventFields); // 插件

    var plugins = options.plugins || ['utm-data-tracker'];

    if (!Array.isArray(plugins)) {
      throw new Error('plugins must be array.');
    }

    _this.resolvePlugins(plugins);

    if (_this.batch) {
      window.addEventListener('beforeunload', function () {
        return _this.trackSend();
      });
    }

    return _this;
  }
  /**
   * 设置对应层级的无垠数据。
   * 如果字段存在则覆盖。
   * @param {module:trackers/wind/store~Scope} scope 无垠数据层级。
   * @param {!Object} fieldsObject 无垠数据字段对象。
   * @see {@link module:trackers/wind/store~Store#set}
   */


  _createClass(WindTracker, [{
    key: "set",
    value: function set(scope, fieldsObject) {
      this.store.set(scope, fieldsObject);
    }
    /**
     * 获取对应层级的无垠数据。
     * 如果没有传入 fields 参数，默认返回 scope 指定的所有数据，否则返回包含 fields 的字段对象。
     * 若 field 不存在，则不返回该 field 指定的字段值。
     * @param {module:trackers/wind/store~Scope} scope 无垠数据层级。
     * @param  {...string} [fields] 待获取的字段。
     * @return {!Object}
     * @see {@link module:trackers/wind/store~Store#get}
     */

  }, {
    key: "get",
    value: function get(scope) {
      var _this$store;

      for (var _len = arguments.length, fields = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      return (_this$store = this.store).get.apply(_this$store, [scope].concat(fields));
    }
    /**
     * 安装插件。
     * @param {string} pluginName 插件名称
     * @param {Function} pluginConstructor 插件构造函数
     * @param {Object} [pluginOptions] 插件选项
     */

  }, {
    key: "use",
    value: function use(pluginName, pluginConstructor, pluginOptions) {
      var installedPlugins = this.installedPlugins; // eslint-disable-next-line new-cap

      installedPlugins[pluginName] = new pluginConstructor(this, pluginOptions);
    }
  }, {
    key: "resolvePlugins",
    value: function resolvePlugins(plugins) {
      var _this2 = this;

      plugins.forEach(function (plugin) {
        var pluginName;
        var pluginCtr;
        var pluginOptions;

        if (typeof plugin === 'string') {
          pluginName = plugin;
        } else if (Array.isArray(plugin)) {
          var _plugin = _slicedToArray(plugin, 2);

          pluginName = _plugin[0];
          pluginOptions = _plugin[1];
        } else {
          throw new Error('Invalid plugin config.');
        }

        pluginCtr = PLUGINS[pluginName];

        if (!pluginCtr) {
          throw new Error("Can't find plugin '".concat(plugin, "'."));
        }

        _this2.use(pluginName, pluginCtr, pluginOptions);
      });
    }
    /**
     * 执行插件方法。
     * @param {string} method 插件方法名
     * @param  {...any} args 插件方法参数
     */

  }, {
    key: "run",
    value: function run(method) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      for (var pluginName in this.installedPlugins) {
        var plugin = this.installedPlugins[pluginName];
        plugin[method] && plugin[method].apply(plugin, args);
      }
    }
    /**
     * 获取 runtime 数据。
     * @return {!Object}
     * @private
     */

  }, {
    key: "getRuntime",
    value: function getRuntime() {
      var runtime = {};
      var uaParser = new UAParser();
      var parsedUA = uaParser.setUA(window.navigator.userAgent).getResult();
      runtime.os = parsedUA.os.name;
      runtime.model = parsedUA.os.version;
      var screen = window.screen;
      runtime.screen_width = screen.width;
      runtime.screen_height = screen.height;
      return runtime;
    }
    /**
     * 获取 device_id 数据。
     * @return {string}
     * @private
     */

  }, {
    key: "getDeviceId",
    value: function getDeviceId() {
      return getUserDeviceId();
    }
    /**
     * 获取 is_first_day 数据。
     * @return {(0|1)}
     * @private
     */

  }, {
    key: "getIsFirstDay",
    value: function getIsFirstDay() {
      var isFirstDay = 0;
      var timestamp = getTimestamp();

      if (timestamp) {
        try {
          var now = Date.now();
          var night = new Date(timestamp).setHours(23, 59, 59, 999).valueOf();
          isFirstDay = night - now >= 0 ? 1 : 0;
        } catch (e) {// ignore error
        }
      }

      return isFirstDay;
    }
    /**
     * 获取 session_id 数据。
     * @return {string}
     * @private
     */

  }, {
    key: "getSessionId",
    value: function getSessionId() {
      return UUID$1();
    }
    /**
     * 获取当前页面的 referrer。
     * 需过滤站内地址。
     * @return {string}
     */

  }, {
    key: "getReferrer",
    value: function getReferrer() {
      var referrer = document.referrer;
      var domain = getDomain();

      if (referrer) {
        var url = new Url(referrer);

        if (url.hostname && url.hostname.includes(domain)) {
          return '';
        }
      }

      return referrer;
    }
    /**
     * 注册 beforeEach 钩子函数。
     * @param {Function} fn 钩子函数，在 trackEvent 发送之前调用。
     */

  }, {
    key: "beforeEach",
    value: function beforeEach(fn) {
      this.beforeEachFns.push(fn);
    }
    /**
     * 上报事件。
     * @param {string} event 事件名称。
     * @param {Object} details 事件详情，包括 event_id 属性以及可选的无垠数据业务数据。
     * @param {number} details.event_id 事件 ID。
     * @param {Function} [callback] 回调函数。
     */

    /**
     * 上报事件。
     * @param {string} event 事件名称。
     * @param {Object} details 事件详情，包括 event_id 属性以及可选的无垠数据业务数据。
     * @param {number} details.event_id 事件 ID。
     * @param {ScopeObject} [scopeObject] 无垠数据层级对象。
     * @param {Function} [callback] 回调函数。
    */

  }, {
    key: "trackEvent",
    value: function trackEvent(event, details, scopeObject, callback) {
      var _this3 = this;

      if (typeof scopeObject === 'function') {
        callback = scopeObject;
        scopeObject = undefined;
      }

      scopeObject = scopeObject || {};
      var basicFields = scopeObject.basic || {};
      var commonFields = scopeObject.common || {};
      var eventFields = scopeObject.event || {};
      /* eslint-disable camelcase */

      var event_id = details.event_id,
          restDetails = _objectWithoutProperties(details, ["event_id"]); // 判断 event_id 是否存在


      if (!event_id && this.debug) {
        error('details\'s property "event_id" is required.');
        return;
      }

      var store = this.store.clone();
      store.set('basic', basicFields);
      store.set('common', _objectSpread({
        event_id: event_id,
        event: event
      }, commonFields));
      store.set('event', eventFields);

      if (Object.keys(restDetails).length) {
        store.set('event', {
          detail: restDetails
        });
      }

      validate(store); // 添加埋点校验提醒

      var loginFn = function loginFn(store, next) {
        if (!_this3.needLogin || _this3.isLogin) {
          next(store);
          return;
        }

        _this3.loginQueue.push({
          store: store,
          next: next
        });
      };

      var terminatingFn = function terminatingFn(store) {
        var data = store.toJSON();
        _this3.showLog && info("".concat(JSON.stringify(data, null, '  ')));

        if (_this3.batch) {
          _this3.trackQueue(data);
        } else {
          // 组装请求参数;
          var params = {
            gzip: 0,
            use_client_time: false,
            data: base64encode(JSON.stringify(data))
          }; // 数据上报

          request(_this3.serverUrl, params, callback, _this3.transport);
        }
      }; // 调用 beforeEach 钩子函数集合


      var fns = [loginFn].concat(_toConsumableArray(this.beforeEachFns), [terminatingFn]);
      var i = -1;

      var next = function next(store) {
        i += 1;

        if (i < fns.length - 1) {
          fns[i](store, next);
        } else {
          fns[i](store);
        }
      };

      next(store);
    }
  }, {
    key: "trackQueue",
    value: function trackQueue(data) {
      var _this4 = this;

      this.sendQueue.push(JSON.parse(JSON.stringify(data)));

      if (this.sendTimer) {
        if (this.sendQueue.length >= this.sendCount) {
          this.trackSend();
        }
      } else {
        this.sendTimer = setTimeout(function () {
          return _this4.trackSend();
        }, this.sendTime);
      }
    }
  }, {
    key: "trackSend",
    value: function trackSend() {
      clearTimeout(this.sendTimer);
      var datas = this.sendQueue.map(function (item) {
        return item.data;
      }); // eslint-disable-next-line no-unused-vars

      var _this$sendQueue$ = this.sendQueue[0],
          data = _this$sendQueue$.data,
          otherData = _objectWithoutProperties(_this$sendQueue$, ["data"]);

      request(this.serverUrl, {
        gzip: 0,
        use_client_time: false,
        data_list: base64encode(JSON.stringify(_objectSpread({
          list: datas
        }, otherData)))
      }, undefined, 'beacon'); // 批量上报默认用 beacon ，因为 image 上报方式 get 请求有限制

      this.sendTimer = null;
      this.sendQueue = [];
    }
    /**
     * 上报 page_visit 事件。
     * @param {Object} [details] 事件详情，包含无垠数据业务数据。
     * @param {number} [details.event_id=1] 事件 ID。
     * @param {string} [details.page] pv 地址。域名 + 路由。
     * @param {string} [details.page_params] 路由参数。
     * @param {string} [details.source_page] 来源页面。
     * @param {Function} [callback] 回调函数。
     */

  }, {
    key: "trackPageView",
    value: function trackPageView() {
      var details = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      var event_id = details.event_id,
          page = details.page,
          page_params = details.page_params,
          source_page = details.source_page,
          restDetails = _objectWithoutProperties(details, ["event_id", "page", "page_params", "source_page"]);

      var eventDetails = {};
      restDetails.event_id = !event_id ? EVENT_ID.page_visit : event_id;
      if (page) eventDetails.page = page;
      if (page_params) eventDetails.page_params = page_params;
      if (source_page) eventDetails.source_page = source_page;
      eventDetails.page_time = Date.now();
      this.store.set('event', eventDetails);
      this.trackEvent('page_visit', restDetails, callback);
    }
    /**
     * 上报用户属性。
     * @param {Object} [details] 用户详情。
     * @param {Function} [callback] 回调函数。
     */

  }, {
    key: "trackProfile",
    value: function trackProfile(details, callback) {
      this.trackEvent('user_profile', _objectSpread({
        event_id: EVENT_ID.user_profile
      }, details), callback);
    }
    /**
     * 设置用户属性。
     * @param {Object} [details] 用户详情。
     * @param {(1|2)} details.vipLevel vip订购版本，1表示标准vip，2表示尊享vip。
     */

  }, {
    key: "setProfile",
    value: function setProfile(details) {
      var vipLevel = details.vipLevel;
      this.store.set('common', {
        vip_level: vipLevel
      });
    }
    /**
     * 关联游客 ID 或者登陆用户 ID，并且上报 login 事件。
     * @param {string} userId 游客 ID 或者登陆用户 ID。
     * @param {Object} details 登陆事件详情，包括 type 属性以及可选的无垠数据业务数据。
     * @param {(0|1)} details.type 用户类型，0表示游客，1表示登录用户。
     * @param {(1|2)} details.vipLevel vip订购版本，1表示标准vip，2表示尊享vip。
     * @param {string} details.client_name 插件名称（ps助理使用）PS助理 达芬奇配色 智能参考
     * @param {boolean} details.is_cache_login 是否缓存登陆
     * @param {boolean} details.is_verify_code_login 是否验证码登陆
     * @param {string} details.login_type 登录方式主站 手机 微信 QQ
     * @param {boolean} [details.track=true] 是否上报 login 事件，默认上报。
     * @param {Function} [callback] 回调函数。
     */

  }, {
    key: "login",
    value: function login(userId, details, callback) {
      var type = details.type;
      var vipLevel = details.vipLevel;
      var track = details.track === undefined ? true : details.track; // 判断 type 是否存在

      if (type === undefined && this.debug) {
        error('details\'s property "type" is required');
        return;
      }

      delete details.type;
      delete details.vipLevel;
      this.store.set('common', {
        user_id: '' + userId,
        is_login: type,
        vip_level: vipLevel
      });
      this.isLogin = true;

      if (track && type === 1) {
        delete details.track;
        this.trackEvent('login', _objectSpread({
          event_id: EVENT_ID.login
        }, Object.assign(INIT_EVENT_DETAILS['login'], details)), callback);
      }

      this.loginQueue.forEach(function (_ref) {
        var store = _ref.store,
            next = _ref.next;
        store.set('common', {
          user_id: '' + userId,
          is_login: type,
          vip_level: vipLevel
        });
        next(store);
      });
      this.loginQueue = [];
    }
    /**
     * 取消关联用户 ID。
     */

  }, {
    key: "logout",
    value: function logout() {
      this.store.set('common', {
        user_id: '',
        is_login: 0
      });
      this.isLogin = false;
    }
    /**
     * 添加编辑器会话 ID。
     * @param {string} [sessionId] 编辑器会话ID
     */

  }, {
    key: "editSessionStart",
    value: function editSessionStart(sessionId) {
      var _this$store$get = this.store.get('event', 'source_page'),
          source_page = _this$store$get.source_page;

      this.store.set('event', {
        editor_session_id: sessionId || "".concat(Math.random().toString(16).slice(2)).concat(Math.random().toString(16).slice(2)),
        editor_source_page: source_page
      });
    }
    /**
     * 清空编辑器会话 ID。
     */

  }, {
    key: "editSessionEnd",
    value: function editSessionEnd() {
      this.store.set('event', {
        editor_session_id: null,
        editor_source_page: null
      });
    }
  }]);

  return WindTracker;
}(EventEmitter);

var version = "1.16.0";

/**
 * 事件属性校验
 *
 */
/**
 * 加载校验脚本
 * @param {string} url 校验脚本url
 *
 * eg https://cdn.dancf.com/packages/gaoding/gd-tracker/1.13.0/gd-tracker.wind-schema.gd_web.js
 */

var customCache = new Set();
var loadSchemaUrl = (function (project) {
  // Make sure in browser environment.
  var scriptUrl = "https://cdn.dancf.com/packages/gaoding/gd-tracker/".concat(version, "/gd-tracker.wind-schema.").concat(project, ".js");

  if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && !customCache.has(scriptUrl)) {
    var script = document.createElement('script');
    script.setAttribute('src', scriptUrl);
    script.setAttribute('data-namespace', scriptUrl);
    customCache.add(scriptUrl);
    document.body.appendChild(script);
  }
});

var trackerWind = {
  /**
   * 跟踪器名称。
   * @type {string}
   */
  name: 'wind',

  /**
   * 跟踪器实例。
   * @type {module:trackers/wind/tracker}
   * @private
   */
  tracker: null,

  /**
   * 初始化无垠数据。
   * @param {Object} options 配置选项
   * @param {string} [options.serverUrl] 数据接收地址。没有该参数时，可通过参数 serverHost 和 debug 自动生成。
   * @param {string} [options.serverHost = 'https://wind.hlgdata.com'] 数据接收域名。用于生成数据接收地址，优先使用 serverUrl 参数。
   * @param {string} options.project 项目名，无垠数据基础公共数据字段。
   * @param {string} options.version 项目版本，无垠数据公共业务数据字段。
   * @param {('env'|'stage'|'prod')} options.env 事件环境，无垠数据公共业务数据字段。
   * @param {Object} [options.coordinates] 坐标信息
   * @param {string} [options.coordinates.region_id='1'] 地区
   * @param {string} [options.coordinates.biz_code='1'] 产品线
   * @param {string} [options.coordinates.endpoint='4'] 用户端
   * @param {'beacon'|'image'|'xhr'} [options.transport] 上报机制。
   * @param {boolean} [options.showLog=false] 是否显示 log 信息。
   * @param {boolean} [options.debug = false] - 调试模式。 用于生成数据接收地址，优先使用 serverUrl 参数。
   * @param {boolean} [isProd=false] 是否生产环境，生产环境下使用调试模式，DevTools Console 会发出警告。
   * @param {boolean} [debug=false] 是否调试模式，优先使用 options.debug 参数。
   */
  setup: function setup(options) {
    var isProd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var debug = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (this.tracker) return;
    this.tracker = new WindTracker(options, isProd, debug);
    loadSchemaUrl(options.project);
  },

  /**
   * 安装插件。
   * @param {string} pluginName 插件名称
   * @param {Function} pluginConstructor 插件构造函数
   * @param {Object} [pluginOptions] 插件选项
   */
  use: function use(pluginName, pluginConstructor, pluginOptions) {
    this.tracker && this.tracker.use(pluginName, pluginConstructor, pluginOptions);
  },

  /**
   * 设置对应层级的无垠数据。
   * 如果字段存在则覆盖。
   * @param {module:trackers/wind/store~Scope} scope 无垠数据层级。
   * @param {!Object} fieldsObject 无垠数据字段对象。
   * @see {@link module:trackers/wind/store~Store#set}
   */
  set: function set(scope, fieldsObject) {
    this.tracker && this.tracker.set(scope, fieldsObject);
  },

  /**
   * 获取对应层级的无垠数据。
   * 如果没有传入 fields 参数，默认返回 scope 指定的所有数据，否则返回包含 fields 的字段对象。
   * 若 field 不存在，则不返回该 field 指定的字段值。
   * @param {module:trackers/wind/store~Scope} scope 无垠数据层级。
   * @param  {...string} [fields] 待获取的字段。
   * @return {!Object}
   * @see {@link module:trackers/wind/store~Store#get}
   */
  get: function get(scope) {
    var _this$tracker;

    for (var _len = arguments.length, fields = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      fields[_key - 1] = arguments[_key];
    }

    return this.tracker && (_this$tracker = this.tracker).get.apply(_this$tracker, [scope].concat(fields));
  },

  /**
   * 注册 beforeEach 钩子函数。
   * @param {Function} fn 钩子函数，在 trackEvent 发送之前调用。
   */
  beforeEach: function beforeEach(fn) {
    return this.tracker && this.tracker.beforeEach(fn);
  },

  /**
   * 上报事件。
   * @param {string} event 事件名称。
   * @param {Object} details 事件详情，包括 event_id 属性以及可选的无垠数据业务数据。
   * @param {number} details.event_id 事件 ID。
   * @param {number} [details.request_id] 请求 ID，用于上报接口相关数据 uri_path, uri_query, bi_meta。
   * @param {Function} [callback] 回调函数。
   */

  /**
  * 上报事件。
  * @param {string} event 事件名称。
  * @param {Object} details 事件详情，包括 event_id 属性以及可选的无垠数据业务数据。
  * @param {number} details.event_id 事件 ID。
  * @param {ScopeObject} [scopeObject] 无垠数据层级对象。
  * @param {Function} [callback] 回调函数。
  */
  trackEvent: function trackEvent(event, details, scopeObject, callback) {
    this.tracker && this.tracker.trackEvent(event, details, scopeObject, callback);
  },

  /**
   * 上报 page_visit 事件。
   * @param {Function} [callback] 回调函数。
   */
  trackPageView: function trackPageView(callback) {
    this.tracker && this.tracker.trackPageView(callback);
  },

  /**
   * 上报用户属性。
   * @param {Object} [details] 用户详情。
   * @param {Function} [callback] 回调函数。
   */
  trackProfile: function trackProfile(details, callback) {
    this.tracker && this.tracker.trackProfile(details, callback);
  },

  /**
   * 设置用户属性。
   * @param {Object} [details] 用户详情。
   * @param {Function} [callback] 回调函数。
   */
  setProfile: function setProfile(details, callback) {
    this.tracker && this.tracker.setProfile(details, callback);
  },

  /**
   * 关联游客 ID 或者登陆用户 ID，并且上报 login 事件。
   * @param {string} userId 游客 ID 或者登陆用户 ID。
   * @param {Object} details 登陆事件详情，包括 type 属性以及可选的无垠数据业务数据。
   * @param {(0|1)} details.type - 用户类型，0表示游客，1表示登录用户。
   * @param {boolean} [details.track=true] 是否上报 login 事件，默认上报。
   * @param {Function} [callback] 回调函数。
   */
  login: function login(userId, details, callback) {
    this.tracker && this.tracker.login(userId, details, callback);
  },

  /**
   * 取消关联用户 ID。
   */
  logout: function logout() {
    this.tracker && this.tracker.logout();
  },

  /**
   * 添加编辑器会话 ID。
   * @param {string} [sessionId] 编辑器会话ID
   */
  editSessionStart: function editSessionStart(sessionId) {
    this.tracker && this.tracker.editSessionStart(sessionId);
  },

  /**
   * 清空编辑器会话 ID。
   */
  editSessionEnd: function editSessionEnd() {
    this.tracker && this.tracker.editSessionEnd();
  },

  /**
   * 获取 utm 相关字段。
   * @return {Object}
   */
  getUtmData: function getUtmData$1() {
    return getUtmData();
  },

  /**
   * 用户注册完成
   * @param {Object} details 事件属性对象
   */
  regist: function regist(details) {
    this.trackEvent('regist', _objectSpread({
      event_id: EVENT_ID.regist
    }, Object.assign(INIT_EVENT_DETAILS.regist, details)));
  },

  /**
   * 支付弹窗曝光时触发上报
   * @param {Object} details 事件属性对象
   */
  orderPayExpose: function orderPayExpose(details) {
    this.trackEvent('order_pay_expose', _objectSpread({
      event_id: EVENT_ID.order_pay_expose
    }, Object.assign(INIT_EVENT_DETAILS.order_pay_expose, details)));
  },

  /**
   * 当用户支付订单时触发上报
   * @param {Object} details 事件属性对象
   */
  orderPayAction: function orderPayAction(details) {
    this.trackEvent('order_pay_action', _objectSpread({
      event_id: EVENT_ID.order_pay_action
    }, Object.assign(INIT_EVENT_DETAILS.order_pay_action, details)));
  },

  /**
   * 素材模板被点击时触发上报
   * @param {Object} details 事件属性对象
   */
  materialClick: function materialClick(details) {
    this.trackEvent('material_click', _objectSpread({
      event_id: EVENT_ID.material_click
    }, Object.assign(INIT_EVENT_DETAILS.material_click, details)));
  },

  /**
   * 资源位被点击时触发上报
   * @param {Object} details 事件属性对象
   */
  resourceLocClick: function resourceLocClick(details) {
    this.trackEvent('resource_loc_click', _objectSpread({
      event_id: EVENT_ID.resource_loc_click
    }, Object.assign(INIT_EVENT_DETAILS.resource_loc_click, details)));
  },

  /**
   * 资源位曝光时触发上报
   * @param {Object} details 事件属性对象
   */
  resourceLocExpose: function resourceLocExpose(details) {
    this.trackEvent('resource_loc_expose', _objectSpread({
      event_id: EVENT_ID.resource_loc_expose
    }, Object.assign(INIT_EVENT_DETAILS.resource_loc_expose, details)));
  },

  /**
   * 用户触发搜索事件后触发上报
   * @param {Object} details 事件属性对象
   */
  search: function search(details) {
    this.trackEvent('search', _objectSpread({
      event_id: EVENT_ID.search
    }, Object.assign(INIT_EVENT_DETAILS.search, details)));
  },

  /**
   * 弹窗按钮操作时触发上报
   * @param {Object} details 事件属性对象
   */
  dialogAction: function dialogAction(details) {
    this.trackEvent('dialog_action', _objectSpread({
      event_id: EVENT_ID.dialog_action
    }, Object.assign(INIT_EVENT_DETAILS.dialog_action, details)));
  },

  /**
   * 弹窗曝光时触发上报
   * @param {Object} details 事件属性对象
   */
  dialogExpose: function dialogExpose(details) {
    this.trackEvent('dialog_expose', _objectSpread({
      event_id: EVENT_ID.dialog_expose
    }, Object.assign(INIT_EVENT_DETAILS.dialog_expose, details)));
  }
};

var trackerLR = {
  name: 'lr',
  LogRocket: null,
  appId: null,
  // logrocket项目id
  hasInit: null,
  // 录屏的开启状态
  importLogRocket: function importLogRocket() {
    return Promise.resolve({});
  },
  isTargetUser: function isTargetUser() {
    return Promise.resolve(false);
  },
  // 判断是否对当前用户开启录屏
  // setup不会开启录屏，而只是记录下相关数据并设置好是否开启录屏的判断函数，这个函数会在login时被调用
  setup: function setup(_ref, isProd, debug) {
    var LogRocket = _ref.LogRocket,
        appId = _ref.appId,
        ab = _ref.ab,
        scale = _ref.scale;
    this.appId = appId;
    this.importLogRocket = LogRocket; // 以ab方式判断是否开启

    if (ab) {
      var appInfo = isProd ? {
        app_key: 'ABTEST_f6519045-8bfd-4f0d-b690-8ab5b019bf8c',
        app_name: 'gd_web'
      } : {
        app_key: 'ABTEST_5efd644b-019b-426c-8ade-805e77d7aa52',
        app_name: 'gd_web_dev'
      };

      this.isTargetUser = function (userId, userType) {
        ab.instance.init(_objectSpread({}, appInfo, {
          user_id: userId,
          device_id: getUserDeviceId(),
          is_login: userType || '0'
        }));
        return ab.instance.getValue(ab.flag, '0').then(function (value) {
          return Boolean(+value);
        });
      }; // 以硬编码灰度的灰度值判断是否开启（非debug模式下，仅对线上环境生效）

    } else if (scale && (isProd || debug)) {
      this.isTargetUser = function (userId) {
        var isInScale = userId % (100 / scale) === 0;
        return Promise.resolve(isInScale);
      };
    }
  },
  // 1. 初始状态下（hasInit的值为null），调用判断函数，决定是否开启录屏，并改写hasInit的值
  // 2. 开启状态下（hasInit的值为true），记录新的用户信息（保证使用该用户信息也能搜索到本次会话）
  // 3. 关闭状态（hasInit的值为false），不做任何处理
  // 只有第一次登录时会判断是否开启，后续登录/登出并不会影响录屏服务的关停（保证会话完整性）
  login: function login(userId, profile) {
    var _this = this;

    if (this.hasInit == null) {
      this.isTargetUser(userId, profile.type).then(function (result) {
        if (result) {
          _this.init(userId, profile);
        }

        _this.hasInit = result;
      });
    } else if (this.hasInit && this.LogRocket) {
      this.LogRocket.identify(userId, profile);
    }
  },
  // 不需要对登出做处理
  logout: function logout() {},
  init: function init(uid, profile) {
    var _this2 = this;

    this.importLogRocket().then(function (_ref2) {
      var LogRocket = _ref2.default;

      if (LogRocket) {
        _this2.LogRocket = LogRocket;
        LogRocket.init(_this2.appId);
        LogRocket.identify(uid, profile); // 记录用户身份
      }
    });
  },
  // 记录用户行为，用于筛选会话
  trackEvent: function trackEvent(event) {
    if (this.hasInit && this.LogRocket) {
      this.LogRocket.track(event);
    }
  },
  // 外部的统一调用预设每个埋点sdk都有此方法，此方法对录屏服务无意义
  trackPageView: function trackPageView() {}
};

var extTrackers = [trackerHMT, trackerWind, trackerLR];
var tracker = {
  trackerHMT: trackerHMT,
  trackerWind: trackerWind,
  trackerLR: trackerLR,
  inited: false,
  readyQueue: [],

  /**
   *
   * @function
   * @name setup
   * @description 注入统计脚本 使用任何其他 `tracker` 接口前，请务必使用该方法初始化统计脚本。
   *
   * @param {Object} trackerOptions - 统计脚本参数
   * @param {Object} trackerOptions.trackerName - 对应统计工具的注入参数，sa - 神策，gio - Growing.IO，_hmt - 百度。
   * @param {Boolean} [isProd=false] - 是否生产环境
   * @param {Boolean} [debug=false] - 是否调试模式
   *
   * @returns {Promise} - 该方法已使用兼容队列，调用其他接口前不用等待该 Promise resolved。
   *
   * @example
   *  // options
   *  const trackerOptions = {
   *      sa: {
   *          name: 'sc',
   *          sdk_url: 'link_to_sensordata.min.js',
   *          heatmap_url: 'link_to_heatmap.min.js',
   *          server_url: 'your_server_url',
   *          server_host: 'your_server_host',
   *          project: 'your_project_name',
   *          debug: false,
   *          heatmap: {},
   *          show_log: true,
   *          project_fields: {
   *              sou_from: () => {
   *                  return 'tracker_demo';
   *              }
   *          },
   *          track_sou_from: true
   *      },
   *      _hmt: {
   *          projectId: 'your_baidu_app_id'
   *      }
   *      gio: {
   *          projectId: 'your_baidu_app_id'
   *      }
   *  };
   *
   *  // setup tracking tools
   *  tracker.setup(trackerOptions, isProd, debugMode);
   */
  setup: function setup(trackerOptions) {
    var _this = this;

    var isProd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var debug = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return promiseMap(Object.keys(trackerOptions), function (trackerName) {
      var _tracker = extTrackers.find(function (item) {
        return item.name === trackerName;
      });

      if (_tracker) {
        return _tracker.setup(trackerOptions[trackerName], isProd, debug);
      }
    }).then(function () {
      _this.inited = true;

      _this.readyQueue.forEach(function (fn) {
        return fn();
      });

      _this.readyQueue = [];
    }); // TODO: debug - sa trackerOptions is rewritten after setup.
  },
  onReady: function onReady(fn) {
    if (this.inited) {
      fn();
      return;
    }

    this.readyQueue.push(fn);
  },

  /**
   * @function
   * @name login
   * @description 关联用户 ID，设置用户属性
   *
   * @param {Number|Object} [userId] - 用户 ID | 用户信息。v0.x 兼容 {Object} user，v1.x 弃用。
   * @param {Object} [profiles] - 直接设置的用户属性，如果存在则覆盖。
   * @param {*|Function} [profiles.key] - 用户属性 key 对应的值，支持函数或值。
   * @param {Object} [onceProfiles] - 仅设置一次的用户属性，如果不存在则设置，存在就不设置。对神策生效。
   * @param {*|Function} [onceProfiles.key] - 一次性用户属性 key 对应的值，支持函数或值。
   * @param {Array} [keyMap] - 指定 profiles key 对应的 tag。对百度生效。
   * @param {String} [keyMap.key] - profiles key 对应的 tag。对百度生效。
   *
   * @example
   * // link user and set profiles, once profiles
   * tracker.login(666, {
   *     type: 1
   * },{
   *     source: 'demo'
   * });
   */
  // TODO: userId and profile, profileOnce
  login: function login(userId, profiles, onceProfiles) {
    // compatible for old param user in v0.x
    var uid = _typeof(userId) === 'object' ? userId.id : userId;

    for (var _i = 0; _i < extTrackers.length; _i++) {
      var extTracker = extTrackers[_i];
      extTracker.login(uid, Object.assign({}, profiles), onceProfiles);
    }
  },

  /**
   * @function
   * @name logout
   * @description 取消关联用户 ID
   *
   * @example
   * // remove link to logined user
   * tracker.logout();
   */
  logout: function logout() {
    for (var _i2 = 0; _i2 < extTrackers.length; _i2++) {
      var extTracker = extTrackers[_i2];
      extTracker.logout();
    }
  },

  /**
   *
   * @function
   * @name trackPageView
   * @description 上报 PV - 当配置中自动 PV 无法生效时调用该方法。
   *
   * @param {String} [path] - 当前地址。请使用相对路径。对于首屏访问的 PV，需要传入相对路径以避免与自动 PV 重复。
   * @param {String} [referrer] - 前向地址。请使用绝对路径。
   *
   * @example
   * // track PV
   * tracker.trackerPageView();
   */
  trackPageView: function trackPageView(path) {
    var referrer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.referrer;
    // FIXME: 暂时去除 trackerWind
    var trackers = extTrackers.filter(function (t) {
      return t.name !== 'wind';
    });
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = trackers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _tracker2 = _step.value;

        _tracker2.trackPageView(path, referrer);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  },

  /**
   * @function
   * @name trackEvent
   * @description 上报自定义事件。默认支持神策自定义事件埋点。
   *
   * @param {string} eventName - 事件名
   * @param {Array} restArgs - tracker 需要的剩余参数
   * @example
   * // track custom events
   * tracker.trackerEvent('event_name', {
   *     sc_but: 'test'
   * });
   *
   * // track custom events for wind
   * tracker.trackerEvent('wind:event_name', {
   *     sc_but: 'test'
   * });
   */
  trackEvent: function trackEvent(eventName) {
    var event = eventName.split(':');

    for (var _len = arguments.length, restArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      restArgs[_key - 1] = arguments[_key];
    }

    if (event.length === 1) {
      trackerWind.trackEvent.apply(trackerWind, [eventName].concat(restArgs));
      return;
    }

    var _event = _slicedToArray(event, 2),
        scope = _event[0],
        name = _event[1];

    var tracker = extTrackers.find(function (t) {
      return t.name === scope;
    });

    if (tracker) {
      tracker.trackEvent.apply(tracker, [name].concat(restArgs));
    }
  },

  /**
   * @function
   * @name newEditSession
   * @description 用于生成会话ID，需要在进入编辑器的时候调用。调用后编辑器的埋点会上报 edit_id 字段用来标示编辑会话
   * 目前只有神策使用
   * @param {string} [sessionId] 编辑器会话ID
   */
  editSessionStart: function editSessionStart(sessionId) {
    for (var _i3 = 0; _i3 < extTrackers.length; _i3++) {
      var extTracker = extTrackers[_i3];
      extTracker.editSessionStart && extTracker.editSessionStart(sessionId);
    }
  },

  /**
   * @function
   * @name closeEditSession
   * @description 关闭会话，结束编辑器的时候调用。关闭后不再上报 edit_id 字段。
   */
  editSessionEnd: function editSessionEnd() {
    for (var _i4 = 0; _i4 < extTrackers.length; _i4++) {
      var extTracker = extTrackers[_i4];
      extTracker.editSessionEnd && extTracker.editSessionEnd();
    }
  }
};

var initTracker = {
  trackerDisabled: false,
  _tracker: tracker,
  pendingLogs: [],
  trackEvent: function trackEvent() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    this.invoke.apply(this, ['trackEvent'].concat(args));
  },
  login: function login() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    this.invoke.apply(this, ['login'].concat(args));
  },
  logout: function logout() {
    this.invoke('logout');
  },
  trackPageView: function trackPageView() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    this.invoke.apply(this, ['trackPageView'].concat(args));
  },
  invoke: function invoke(type) {
    if (this.trackerDisabled) return;

    for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      args[_key4 - 1] = arguments[_key4];
    }

    if (this._tracker.inited) {
      var _this$_tracker;

      (_this$_tracker = this._tracker)[type].apply(_this$_tracker, args);
    } else {
      this.pendingLogs.push({
        type: type,
        args: args
      });
    }
  },
  editSessionStart: function editSessionStart() {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    this.invoke.apply(this, ['editSessionStart'].concat(args));
  },
  editSessionEnd: function editSessionEnd() {
    this.invoke('editSessionEnd');
  }
}; // 神策统计

var vuePlugin = {
  install: function install(Vue) {
    var _Vue$config;

    Vue.directive('gdt-click', vGdtClick);
    Vue.directive('gdt-expose', vGdtExpose);
    Vue.directive('gdt-hover', vGdtHover);
    Vue.directive('gdt-expose-material', vGdtExposeMaterial);
    Vue.directive('gdt-expose-resoure-loc', vGdtExposeResoureLoc);
    Vue.directive('gdt-id', vGdtId);

    if (Vue !== null && Vue !== void 0 && (_Vue$config = Vue.config) !== null && _Vue$config !== void 0 && _Vue$config.globalProperties) {
      Vue.config.globalProperties.$tracker = initTracker;
      tracker.onReady(function () {
        Vue.config.globalProperties.$tracker.pendingLogs.forEach(function (pendingLog) {
          var _Vue$config$globalPro;

          (_Vue$config$globalPro = Vue.config.globalProperties.$tracker).invoke.apply(_Vue$config$globalPro, [pendingLog.type].concat(_toConsumableArray(pendingLog.args)));
        });
        Vue.config.globalProperties.$tracker.pendingLogs = [];
      });
    } else {
      Vue.component('gd-tracker', gdTracker);
      Vue.prototype.$tracker = initTracker;
      tracker.onReady(function () {
        Vue.prototype.$tracker.pendingLogs.forEach(function (pendingLog) {
          var _Vue$prototype$$track;

          (_Vue$prototype$$track = Vue.prototype.$tracker).invoke.apply(_Vue$prototype$$track, [pendingLog.type].concat(_toConsumableArray(pendingLog.args)));
        });
        Vue.prototype.$tracker.pendingLogs = [];
      });
    }
  }
};

function abtestPlugin(tracker, abtest) {
  abtest.on('fetch', function (res) {
    if (res) {
      tracker.trackerSA.projectFields.ab_tags = res.map(function (data) {
        return "".concat(data.experimentId, "_").concat(data.versionId);
      });
    }
  });
}

export { ABTestDataTracker, ApiResponseTracker, PageDurationTracker, RouterChangeTracker, UtmDataTracker, abtestPlugin, tracker, trackerHMT, trackerLR, trackerWind, vuePlugin as vTracker };
